import _regeneratorRuntime from "/home/runner/work/static-frontend/static-frontend/node_modules/@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _toConsumableArray from "/home/runner/work/static-frontend/static-frontend/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/home/runner/work/static-frontend/static-frontend/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "/home/runner/work/static-frontend/static-frontend/node_modules/@babel/runtime/helpers/esm/defineProperty";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var e = Object.defineProperty,
    t = Object.defineProperties,
    n = Object.getOwnPropertyDescriptors,
    r = Object.getOwnPropertySymbols,
    o = Object.prototype.hasOwnProperty,
    l = Object.prototype.propertyIsEnumerable,
    a = function a(t, n, r) {
  return n in t ? e(t, n, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: r
  }) : t[n] = r;
},
    i = function i(e, t) {
  for (var n in t || (t = {})) {
    o.call(t, n) && a(e, n, t[n]);
  }

  if (r) {
    var _iterator = _createForOfIteratorHelper(r(t)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var n = _step.value;
        l.call(t, n) && a(e, n, t[n]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return e;
},
    s = function s(e, r) {
  return t(e, n(r));
},
    c = ("undefined" != typeof require && require, function (e, t) {
  var n = {};

  for (var a in e) {
    o.call(e, a) && t.indexOf(a) < 0 && (n[a] = e[a]);
  }

  if (null != e && r) {
    var _iterator2 = _createForOfIteratorHelper(r(e)),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var a = _step2.value;
        t.indexOf(a) < 0 && l.call(e, a) && (n[a] = e[a]);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  return n;
});

import * as m from "react";
import d, { useState as u, memo as p, useMemo as h, useEffect as E, useRef as k, useContext as g, createContext as f, useCallback as v } from "react";
import L from "clsx";
import { ThumborImage as C } from "react-thumbor-img";
import { chakra as w, useMultiStyleConfig as y, Box as x, StylesProvider as b, useStyles as N, Icon as M, useStyleConfig as j, Flex as A, Popover as F, PopoverTrigger as B, Button as S, Text as Z, PopoverContent as V, PopoverCloseButton as _, PopoverBody as H, LinkBox as z, Grid as R, Heading as D, useDisclosure as T, usePopper as I, useMergeRefs as $, useOutsideClick as P, theme as W, extendTheme as O } from "@chakra-ui/react";
import q from "showdown";
import { FormControl as G, InputLabel as Y, Select as U, MenuItem as J, TextField as X, InputAdornment as K, Typography as Q, createMuiTheme as ee } from "@material-ui/core";
import { Popup as te, _MapContext as ne } from "react-map-gl";
import { Temporal as re } from "@js-temporal/polyfill";
import oe from "@chakra-ui/descendant";

function le(e) {
  for (var _len = arguments.length, t = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    t[_key - 1] = arguments[_key];
  }

  return L("ui-".concat(e), t);
}

var ae = function ae(e) {
  var t = e.text,
      n = e.className;
  if (!t) return null;
  var r = t.split("\n"),
      o = [];

  for (var _l = 0; _l < r.length; _l++) {
    o.push(r[_l]), _l < r.length - 1 && o.push(d.createElement("br", {
      key: r.length + _l
    }));
  }

  return d.createElement("p", {
    className: le("paragraph", n)
  }, o);
},
    ie = function ie(e) {
  var t = e,
      _t$color = t.color,
      n = _t$color === void 0 ? "blue" : _t$color,
      r = t.className,
      o = t.children,
      l = c(t, ["color", "className", "children"]);
  return d.createElement("h1", i({
    className: le("hypertext", ["typography-".concat(n), r])
  }, l), o);
},
    se = function se(e) {
  var t = e,
      _t$color2 = t.color,
      n = _t$color2 === void 0 ? "blue" : _t$color2,
      r = t.className,
      o = t.children,
      l = c(t, ["color", "className", "children"]);
  return d.createElement("h2", i({
    className: le("headline", ["typography-".concat(n), r])
  }, l), o);
},
    ce = function ce(e) {
  var t = e,
      _t$color3 = t.color,
      n = _t$color3 === void 0 ? "yellow" : _t$color3,
      r = t.className,
      o = t.children,
      l = c(t, ["color", "className", "children"]);
  return d.createElement("h3", i({
    className: le("secondary-headline", ["typography-".concat(n), r])
  }, l), o);
},
    me = function me(e) {
  var t = e,
      _t$color4 = t.color,
      n = _t$color4 === void 0 ? "dark-blue" : _t$color4,
      r = t.className,
      o = t.children,
      l = c(t, ["color", "className", "children"]);
  return d.createElement("div", i({
    className: le("headline-label", ["typography-".concat(n), r])
  }, l), o);
},
    de = function de(e) {
  var t = e,
      _t$color5 = t.color,
      n = _t$color5 === void 0 ? "blue" : _t$color5,
      _t$size = t.size,
      r = _t$size === void 0 ? "font14" : _t$size,
      o = t.className,
      l = t.children,
      a = c(t, ["color", "size", "className", "children"]);
  return d.createElement("div", i({
    className: le("title", [r, "typography-".concat(n), o])
  }, a), l);
},
    ue = function ue(e) {
  var t = e,
      _t$color6 = t.color,
      n = _t$color6 === void 0 ? "green" : _t$color6,
      r = t.className,
      o = t.children,
      l = c(t, ["color", "className", "children"]);
  return d.createElement("div", i({
    className: le("title-label", ["typography-".concat(n), r])
  }, l), o);
},
    pe = function pe(e) {
  var t = e,
      _t$color7 = t.color,
      n = _t$color7 === void 0 ? "black" : _t$color7,
      r = t.className,
      o = t.children,
      l = c(t, ["color", "className", "children"]);
  return d.createElement("div", i({
    className: le("sub-headline", ["typography-".concat(n), r])
  }, l), o);
},
    he = function he(e) {
  var _ref;

  var t = e,
      _t$color8 = t.color,
      n = _t$color8 === void 0 ? "dark-grey" : _t$color8,
      _t$size2 = t.size,
      r = _t$size2 === void 0 ? "normal" : _t$size2,
      o = t.italic,
      l = t.center,
      a = t.className,
      s = t.children,
      m = c(t, ["color", "size", "italic", "center", "className", "children"]);
  return d.createElement("div", i({
    className: le("body-text", ["typography-".concat(n), (_ref = {}, _defineProperty(_ref, r, r), _defineProperty(_ref, "italic", o), _defineProperty(_ref, "center", l), _ref), a])
  }, m), s);
},
    Ee = function Ee(e) {
  var t = e,
      n = t.children,
      r = t.className,
      o = c(t, ["children", "className"]);
  return d.createElement("span", i({
    className: le("error-message", r)
  }, o), n);
},
    ke = function ke(e) {
  var t = e,
      n = t.icon,
      r = t.name,
      o = t.value,
      l = t.className,
      a = c(t, ["icon", "name", "value", "className"]);
  return d.createElement("div", i({
    className: le("property-pin", l)
  }, a), d.createElement(n, {
    className: le("property-icon")
  }), d.createElement(he, {
    color: "dark-grey",
    className: le("property-name")
  }, r), d.createElement(he, {
    color: "dark-blue",
    className: le("property-value")
  }, o));
},
    ge = function ge(_ref2) {
  var e = _ref2.size,
      t = _ref2.src,
      n = _ref2.className;
  var r = le("document-preview", n);
  return d.createElement("a", {
    href: t,
    target: "_blank",
    rel: "noreferrer noopener",
    className: r,
    style: {
      width: e,
      height: e
    }
  }, d.createElement(C, {
    width: e,
    height: e,
    src: t
  }));
};

var fe = function fe(e) {
  var _ref3 = function (e) {
    var _le;

    var t = e,
        _t$link = t.link,
        n = _t$link === void 0 ? "#" : _t$link,
        _t$variant = t.variant,
        r = _t$variant === void 0 ? "rectangular-fill" : _t$variant,
        o = t.className,
        _t$color9 = t.color,
        l = _t$color9 === void 0 ? "blue" : _t$color9,
        _t$component = t.component,
        a = _t$component === void 0 ? "a" : _t$component,
        m = t.action,
        d = t.disabled,
        u = t.noFollow,
        p = c(t, ["link", "variant", "className", "color", "component", "action", "disabled", "noFollow"]);
    return {
      Component: a,
      newProps: s(i({}, p), {
        onClick: function onClick(e) {
          var t = e;
          (d || "#" === n) && t.preventDefault(), d || m && m(t);
        },
        className: le("button", o, (_le = {}, _defineProperty(_le, r, !0), _defineProperty(_le, l, !0), _defineProperty(_le, "disabled", d), _le)),
        to: e.component ? n : void 0,
        href: e.component ? void 0 : n,
        rel: u ? "nofollow" : void 0
      })
    };
  }(e),
      t = _ref3.Component,
      n = _ref3.newProps,
      r = n,
      o = r.text,
      l = r.children,
      a = c(r, ["text", "children"]);

  return d.createElement(t, i({}, a), o || l);
},
    ve = function ve(e) {
  return d.createElement(fe, i({}, e));
},
    Le = function Le(e) {
  return d.createElement(fe, s(i({}, e), {
    className: "bold-16"
  }));
},
    Ce = function Ce(e) {
  return d.createElement(fe, i({
    variant: "rectangular-stroke"
  }, e));
},
    we = function we(e) {
  return d.createElement(Ce, i({
    color: "blue"
  }, e));
},
    ye = function ye(e) {
  return d.createElement(Ce, i({
    color: "white"
  }, e));
},
    xe = function xe(e) {
  return d.createElement(Ce, i({
    color: "dark-grey"
  }, e));
},
    be = {
  left: 180,
  right: 0,
  up: -90,
  down: 90
},
    Ne = function Ne(e) {
  var t = e,
      n = t.direction,
      r = t.size,
      o = c(t, ["direction", "size"]);
  var l = "rotate(".concat(be[n], ", 9, 9)");
  return d.createElement("svg", i({
    width: r,
    height: r,
    viewBox: "0 0 18 18",
    fill: "none"
  }, o), d.createElement("g", {
    transform: l
  }, d.createElement("path", {
    d: "M5,1l8,8l-8,8",
    stroke: "currentColor",
    strokeWidth: "2",
    vectorEffect: "non-scaling-stroke"
  })));
},
    Me = function Me(e) {
  return d.createElement("svg", i({
    width: "23",
    height: "17",
    viewBox: "0 0 23 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e), d.createElement("path", {
    d: "M1 8.24182L7.72961 14.9714L21.701 1",
    stroke: "currentColor",
    strokeWidth: "2",
    vectorEffect: "non-scaling-stroke"
  }));
},
    je = function je(e) {
  return d.createElement("svg", i({
    version: "1.1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 490 490"
  }, e), d.createElement("polygon", {
    points: "512,59.076 452.922,0 256,196.922 59.076,0 0,59.076 196.922,256 0,452.922 59.076,512 256,315.076 452.922,512 \r\n\t\t\t512,452.922 315.076,256  "
  }));
},
    Ae = function Ae(e) {
  return d.createElement("svg", i({
    width: "44",
    height: "28",
    viewBox: "0 0 44 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e), d.createElement("path", {
    d: "M16 27L25 22L16 27Z",
    fill: "#EB7A0C"
  }), d.createElement("path", {
    d: "M18.1626 18.7551L15.2432 27.9617L23.8906 22.3676L18.1626 18.7551Z",
    fill: "#A4C2F7"
  }), d.createElement("path", {
    d: "M18.1628 18.7552L15.29 27.9618L13.0537 15.9224L42.9781 1.05029L18.1628 18.7552Z",
    fill: "#A4C2F7"
  }), d.createElement("path", {
    d: "M42.2791 2.34748C42.0179 2.35575 41.7735 2.22252 41.6449 2.00171L18.1631 18.7551L32.7604 27.9617L42.5027 2.30343C42.4308 2.32883 42.3554 2.34368 42.2791 2.34748Z",
    fill: "#A4C2F7"
  }), d.createElement("path", {
    d: "M38.5333 3.69701L18 18.3333L31.2 26L40 3L38.5333 3.69701Z",
    fill: "#E3E7F2"
  }), d.createElement("path", {
    d: "M40.4641 1L1 8.80133L13.2868 15L41 1.42276C40.7553 1.38353 40.551 1.22237 40.4641 1Z",
    fill: "white"
  }), d.createElement("path", {
    d: "M38.4614 2L3 9.94445L13.1318 15L39 2.44331C38.754 2.40209 38.5487 2.23318 38.4614 2Z",
    fill: "#E3E7F2"
  }), d.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9774 27.9951C32.8363 27.9952 32.6981 27.956 32.5797 27.8824L17.9824 18.7895C17.7813 18.6644 17.6571 18.4527 17.6502 18.2232C17.6432 17.9936 17.7543 17.7753 17.9474 17.6392L35.4591 5.29973L13.6038 16.0272C13.3922 16.1313 13.1408 16.1301 12.9303 16.0238L0.476277 9.72865C0.203755 9.59082 0.0508855 9.3039 0.0941898 9.01157C0.137494 8.71923 0.367668 8.4844 0.669407 8.42473L43.0344 0.0339835C43.3263 -0.0290165 43.6287 0.0849835 43.7978 0.321567C43.8131 0.342484 43.827 0.3644 43.8391 0.38715C43.9073 0.508817 43.9361 0.647234 43.9218 0.784734C43.9183 0.820984 43.9116 0.856817 43.9018 0.891984C43.8951 0.916984 43.8871 0.94165 43.8775 0.965734L33.6624 27.5374C33.5569 27.8126 33.2833 27.9954 32.9774 27.9951ZM19.6624 18.1672L32.6089 26.2315L41.6709 2.65907L19.6624 18.1672ZM13.276 14.6166L2.95602 9.40007L38.0722 2.44523L13.276 14.6166Z",
    fill: "#007AFF"
  }), d.createElement("path", {
    d: "M15.4611 27.9951C15.1393 27.9953 14.8553 27.7937 14.762 27.4987C14.6686 27.2036 14.7878 26.8847 15.0555 26.7137L23.7027 21.1891C23.9197 21.0483 24.1987 21.0298 24.4339 21.1406C24.669 21.2513 24.8241 21.4743 24.8404 21.7249C24.8566 21.9755 24.7314 22.2152 24.5125 22.353L15.8653 27.8776C15.7456 27.9541 15.605 27.995 15.4611 27.9951Z",
    fill: "#428DFF"
  }), d.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.465 27.9937C15.4793 27.9944 15.4935 27.9951 15.5071 27.9951C15.8286 27.9953 16.1125 27.7935 16.2056 27.4985L19.0081 18.6283L43.6282 1.27987C43.9345 1.06378 44.0163 0.658534 43.8162 0.348617C43.6161 0.0387006 43.2013 -0.0720494 42.8627 0.0941173L12.9383 14.7826C12.6522 14.923 12.4956 15.2261 12.5526 15.5292L14.7886 27.42C14.8486 27.738 15.1282 27.9752 15.465 27.9937ZM15.6873 24.3114L14.0851 15.7909L35.4593 5.29978L17.9475 17.6393C17.8206 17.7288 17.7273 17.8554 17.6817 18L15.6873 24.3114Z",
    fill: "#007AFF"
  }), d.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8734 27.7112C15.011 27.8897 15.2288 27.995 15.4605 27.995C15.6046 27.9952 15.7455 27.9543 15.8654 27.8774L24.5126 22.3529C24.7169 22.2223 24.8391 22.002 24.8376 21.7667C24.8361 21.5314 24.7114 21.3124 24.5054 21.1842L18.7777 17.6159C18.5856 17.4963 18.3461 17.47 18.1308 17.5449C17.9155 17.6199 17.7494 17.7872 17.6821 17.997L14.7627 27.0899C14.6947 27.3021 14.7357 27.5327 14.8734 27.7112ZM16.7606 25.6241L18.7934 19.2942L22.7805 21.7785L16.7606 25.6241Z",
    fill: "#007AFF"
  }));
},
    Fe = function Fe(e) {
  return d.createElement("svg", i({
    width: "12",
    height: "22",
    viewBox: "0 0 12 22",
    fill: "none"
  }, e), d.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.78897 22V11.9648H11.327L11.8567 8.05387H7.78897V5.5569C7.78897 4.42458 8.11918 3.65298 9.82473 3.65298L12 3.65201V0.154089C11.6237 0.106512 10.3325 0 8.8303 0C5.69405 0 3.54703 1.82256 3.54703 5.16969V8.05387H0V11.9648H3.54703V22H7.78897Z",
    fill: "currentColor"
  }));
},
    Be = function Be(e) {
  return d.createElement("svg", i({
    fill: "#fff",
    viewBox: "0 0 512 512"
  }, e), d.createElement("rect", {
    width: "512",
    height: "512",
    fill: "currentColor",
    rx: "15%"
  }), d.createElement("circle", {
    cx: "142",
    cy: "138",
    r: "37"
  }), d.createElement("path", {
    stroke: "#fff",
    strokeWidth: "66",
    d: "M244 194v198M142 194v198"
  }), d.createElement("path", {
    d: "M276 282c0-20 13-40 36-40 24 0 33 18 33 45v105h66V279c0-61-32-89-76-89-34 0-51 19-59 32"
  }));
},
    Se = function Se(e) {
  return d.createElement("svg", i({
    version: "1.1",
    x: "0px",
    y: "0px",
    width: "24.75px",
    height: "24.75px",
    viewBox: "0 0 24.75 24.75"
  }, e), d.createElement("g", null, d.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0,3.875c0-1.104,0.896-2,2-2h20.75c1.104,0,2,0.896,2,2s-0.896,2-2,2H2C0.896,5.875,0,4.979,0,3.875z M22.75,10.375H2\r\n\t\tc-1.104,0-2,0.896-2,2c0,1.104,0.896,2,2,2h20.75c1.104,0,2-0.896,2-2C24.75,11.271,23.855,10.375,22.75,10.375z M22.75,18.875H2\r\n\t\tc-1.104,0-2,0.896-2,2s0.896,2,2,2h20.75c1.104,0,2-0.896,2-2S23.855,18.875,22.75,18.875z",
    fill: "currentColor"
  })));
},
    Ze = function Ze(e) {
  return d.createElement("svg", i({
    width: "26",
    height: "44",
    viewBox: "0 0 26 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e), d.createElement("path", {
    d: "M3.59006 0H12.4099C13.8404 0 15 1.13023 15 2.5244V40.4756C15 41.8698 13.8404 43 12.4099 43H3.59006C2.15962 43 1 41.8698 1 40.4756V2.5244C1 1.13023 2.15954 0 3.59006 0Z",
    fill: "white"
  }), d.createElement("path", {
    d: "M14.5901 0H23.4099C24.8404 0 26 1.13023 26 2.5244V40.4756C26 41.8698 24.8404 43 23.4099 43H14.5901C13.1596 43 12 41.8698 12 40.4756V2.5244C12 1.13023 13.1596 0 14.5901 0Z",
    fill: "#A4C2F7"
  }), d.createElement("path", {
    d: "M5.61923 0H20.3808C21.8273 0 23 1.13023 23 2.5244V40.4756C23 41.8698 21.8273 43 20.3808 43H5.61923C4.17268 43 3 41.8698 3 40.4756V2.5244C3 1.13023 4.17259 0 5.61923 0Z",
    fill: "#E3E7F2"
  }), d.createElement("rect", {
    x: "11",
    y: "5",
    width: "14",
    height: "29",
    fill: "#A4C2F7"
  }), d.createElement("rect", {
    x: "3",
    y: "5",
    width: "20",
    height: "29",
    fill: "url(#paint0_linear)"
  }), d.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.43024 44H22.5696C24.4173 43.9979 25.9147 42.5528 25.9169 40.7695V3.23056C25.9147 1.44719 24.4173 0.0020625 22.5696 0H3.43024C1.58255 0.0020625 0.0852338 1.44719 0.0830078 3.23056V40.7694C0.0852338 42.5528 1.58255 43.9979 3.43024 44ZM1.60267 3.23056C1.60383 2.25689 2.42141 1.46781 3.43024 1.4667H22.5696C23.5785 1.46781 24.396 2.25689 24.3972 3.23056V40.7695C24.396 41.7432 23.5785 42.5323 22.5696 42.5334H3.43024C2.42141 42.5323 1.60383 41.7432 1.60267 40.7695V3.23056Z",
    fill: "#007AFF"
  }), d.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.96094 38.8667C9.96094 40.4867 11.3217 41.8 13.0002 41.8C14.678 41.7982 16.0376 40.486 16.0394 38.8667C16.0394 37.2466 14.6787 35.9333 13.0002 35.9333C11.3217 35.9333 9.96094 37.2466 9.96094 38.8667ZM11.4805 38.8667C11.4805 38.0566 12.1609 37.4 13.0002 37.4C13.839 37.4009 14.5189 38.057 14.5198 38.8667C14.5198 39.6767 13.8395 40.3333 13.0002 40.3333C12.1609 40.3333 11.4805 39.6767 11.4805 38.8667Z",
    fill: "#007AFF"
  }), d.createElement("path", {
    d: "M25.1569 35.2H0.842795C0.423145 35.2 0.0830078 34.8716 0.0830078 34.4667C0.0830078 34.0618 0.423234 33.7334 0.842795 33.7334H25.157C25.5766 33.7334 25.9168 34.0617 25.9168 34.4667C25.9168 34.8717 25.5765 35.2 25.1569 35.2Z",
    fill: "#007AFF"
  }), d.createElement("path", {
    d: "M25.1569 5.86676H0.842795C0.423145 5.86676 0.0830078 5.53839 0.0830078 5.13345C0.0830078 4.72851 0.423234 4.40015 0.842795 4.40015H25.157C25.5766 4.40015 25.9168 4.72851 25.9168 5.13345C25.9168 5.53839 25.5765 5.86676 25.1569 5.86676Z",
    fill: "#007AFF"
  }), d.createElement("path", {
    d: "M13.0002 3.6668H9.96096C9.54131 3.6668 9.20117 3.33844 9.20117 2.9335C9.20117 2.52856 9.5414 2.2002 9.96096 2.2002H13.0002C13.4198 2.2002 13.76 2.52856 13.76 2.9335C13.76 3.33844 13.4198 3.6668 13.0002 3.6668Z",
    fill: "#007AFF"
  }), d.createElement("path", {
    d: "M16.0391 3.6668H15.2793C14.8597 3.6668 14.5195 3.33844 14.5195 2.9335C14.5195 2.52856 14.8597 2.2002 15.2793 2.2002H16.0391C16.4588 2.2002 16.7989 2.52856 16.7989 2.9335C16.7989 3.33844 16.4588 3.6668 16.0391 3.6668Z",
    fill: "#007AFF"
  }), d.createElement("defs", null, d.createElement("linearGradient", {
    id: "paint0_linear",
    x1: "-7.94061",
    y1: "25.9454",
    x2: "22.1254",
    y2: "39.422",
    gradientUnits: "userSpaceOnUse"
  }, d.createElement("stop", {
    stopColor: "#D4E1F4"
  }), d.createElement("stop", {
    offset: "0.1717",
    stopColor: "#D4E1F4"
  }), d.createElement("stop", {
    offset: "0.2",
    stopColor: "#D4E1F4"
  }), d.createElement("stop", {
    offset: "0.2001",
    stopColor: "#DAE4F4"
  }), d.createElement("stop", {
    offset: "0.2007",
    stopColor: "#EBEBF4"
  }), d.createElement("stop", {
    offset: "0.2014",
    stopColor: "#F6F1F4"
  }), d.createElement("stop", {
    offset: "0.2023",
    stopColor: "#FDF4F4"
  }), d.createElement("stop", {
    offset: "0.205",
    stopColor: "#FFF5F4"
  }), d.createElement("stop", {
    offset: "0.2522",
    stopColor: "#FFF5F4"
  }), d.createElement("stop", {
    offset: "0.26",
    stopColor: "#FFF5F4"
  }), d.createElement("stop", {
    offset: "0.26",
    stopColor: "#D4E1F4"
  }), d.createElement("stop", {
    offset: "0.3974",
    stopColor: "#D4E1F4"
  }), d.createElement("stop", {
    offset: "0.42",
    stopColor: "#D4E1F4"
  }), d.createElement("stop", {
    offset: "0.4201",
    stopColor: "#DAE4F4"
  }), d.createElement("stop", {
    offset: "0.4207",
    stopColor: "#EBEBF4"
  }), d.createElement("stop", {
    offset: "0.4214",
    stopColor: "#F6F1F4"
  }), d.createElement("stop", {
    offset: "0.4223",
    stopColor: "#FDF4F4"
  }), d.createElement("stop", {
    offset: "0.425",
    stopColor: "#FFF5F4"
  }), d.createElement("stop", {
    offset: "0.4894",
    stopColor: "#FFF5F4"
  }), d.createElement("stop", {
    offset: "0.5",
    stopColor: "#FFF5F4"
  }), d.createElement("stop", {
    offset: "0.5",
    stopColor: "#F9F2F4"
  }), d.createElement("stop", {
    offset: "0.5001",
    stopColor: "#E8EBF4"
  }), d.createElement("stop", {
    offset: "0.5003",
    stopColor: "#DDE5F4"
  }), d.createElement("stop", {
    offset: "0.5005",
    stopColor: "#D6E2F4"
  }), d.createElement("stop", {
    offset: "0.501",
    stopColor: "#D4E1F4"
  }), d.createElement("stop", {
    offset: "0.7062",
    stopColor: "#D4E1F4"
  }), d.createElement("stop", {
    offset: "0.74",
    stopColor: "#D4E1F4"
  }), d.createElement("stop", {
    offset: "0.741",
    stopColor: "#FFF5F4"
  }), d.createElement("stop", {
    offset: "0.8346",
    stopColor: "#FFF5F4"
  }), d.createElement("stop", {
    offset: "0.85",
    stopColor: "#FFF5F4"
  }), d.createElement("stop", {
    offset: "0.851",
    stopColor: "#D4E1F4"
  }))));
},
    Ve = function Ve(e) {
  return d.createElement("svg", i({
    width: "11",
    height: "18",
    viewBox: "0 0 11 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e), d.createElement("path", {
    d: "M1 16.9975L8.9975 9L1 1",
    stroke: "currentColor",
    strokeWidth: "2",
    vectorEffect: "non-scaling-stroke"
  }));
},
    _e = function _e(e) {
  return d.createElement("svg", i({
    width: "17",
    height: "17",
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e), d.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 15.64L6.30004 16.7104L4.93 14.6834L2.48959 14.5104L2.31658 12.07L0.28963 10.7L1.36 8.5L0.28963 6.30004L2.31658 4.93L2.48959 2.48959L4.93 2.31658L6.30004 0.28963L8.5 1.36L10.7 0.28963L12.07 2.31658L14.5104 2.48959L14.6834 4.93L16.7104 6.30004L15.64 8.5L16.7104 10.7L14.6834 12.07L14.5104 14.5104L12.07 14.6834L10.7 16.7104L8.5 15.64Z",
    fill: "#007AFF"
  }), d.createElement("path", {
    d: "M5 8.59165L7.2756 11L12 6",
    stroke: "currentColor",
    strokeWidth: "2"
  }));
},
    He = function He(e) {
  return d.createElement("svg", i({
    width: "21",
    height: "18",
    viewBox: "0 0 21 18",
    fill: "none"
  }, e), d.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4208 0.332767C19.5876 0.852969 18.6669 1.2313 17.6829 1.43373C16.899 0.551344 15.7787 0 14.5385 0C12.1611 0 10.2317 2.03467 10.2317 4.54397C10.2317 4.90039 10.2687 5.24584 10.3427 5.57861C6.76208 5.38887 3.58794 3.58201 1.46175 0.829323C1.09057 1.50293 0.878621 2.28439 0.878621 3.11659C0.878621 4.69219 1.63893 6.08324 2.79566 6.89814C2.0903 6.87623 1.42475 6.66976 0.842736 6.33181V6.38717C0.842736 8.58966 2.32804 10.4271 4.30059 10.8429C3.9395 10.9496 3.55822 11.0032 3.16517 11.0032C2.88762 11.0032 2.6168 10.9756 2.35439 10.9225C2.90276 12.7271 4.49291 14.0414 6.37855 14.0766C4.90447 15.2958 3.04574 16.0224 1.02777 16.0224C0.680132 16.0224 0.336422 16.0017 0 15.9601C1.90639 17.2474 4.17219 18 6.60452 18C14.5301 18 18.8626 11.0771 18.8626 5.07167C18.8626 4.87386 18.8592 4.67662 18.8519 4.48284C19.6936 3.84211 20.4247 3.0422 21 2.13098C20.2285 2.49201 19.3975 2.73654 18.5262 2.84611C19.416 2.28439 20.0989 1.39393 20.4208 0.332767Z",
    fill: "currentColor"
  }));
},
    ze = function ze(e) {
  return d.createElement("svg", i({
    width: "11",
    height: "18",
    viewBox: "0 0 11 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e), d.createElement("path", {
    d: "M9.99707 16.9975L1.99957 9L9.99707 1",
    stroke: "currentColor",
    strokeWidth: "2",
    vectorEffect: "non-scaling-stroke"
  }));
},
    Re = function Re(e) {
  return d.createElement("svg", i({
    width: "98",
    height: "31",
    viewBox: "0 0 98 31",
    fill: "none",
    className: "yta-logo"
  }, e), d.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1378 17.933V8.74533H30.8172V5.68277H26.1378V0H22.3943V17.831C22.3943 19.7366 22.9569 21.2508 24.0822 22.3738C25.2075 23.4967 26.5667 24.0582 28.16 24.0582C29.7532 24.0582 31.2071 23.457 32.5218 22.2547L30.9843 19.5664C30.249 20.3604 29.4802 20.7574 28.678 20.7574C27.8758 20.7574 27.2519 20.5022 26.8063 19.9918C26.3606 19.4813 26.1378 18.7951 26.1378 17.933ZM13.3363 21.1317C13.3363 25.3967 11.6874 27.5291 8.38949 27.5291C5.91609 27.5291 4.24489 26.3608 3.37585 24.0241L0 25.4874C0.668489 27.2569 1.74363 28.618 3.22544 29.5708C4.70726 30.5236 6.42859 31 8.38949 31C10.952 31 13.041 30.1606 14.6565 28.4819C16.2721 26.8031 17.0798 24.3871 17.0798 21.2338V5.68277H13.3363V13.8496C13.2026 15.483 12.7792 16.7023 12.0662 17.5077C11.3531 18.313 10.2223 18.7157 8.6736 18.7157C7.12494 18.7157 6.03309 18.279 5.39802 17.4056C4.76296 16.5322 4.44543 15.0406 4.44543 12.9308V5.71679H0.70191V14.6323C0.70191 19.7819 3.00816 22.3568 7.62074 22.3568C9.93817 22.3568 11.8433 21.5741 13.3363 20.0088V21.1317ZM49.9025 23.7859H46.4932V21.3699C45.0225 23.1621 43.0505 24.0582 40.5771 24.0582C38.7276 24.0582 37.1957 23.5251 35.9812 22.4588C34.7668 21.3926 34.1596 19.9691 34.1596 18.1883C34.1596 16.4074 34.8058 15.0746 36.0982 14.1899C37.3906 13.3052 39.1398 12.8628 41.3458 12.8628H46.1924V12.1822C46.1924 9.77752 44.8777 8.57519 42.2483 8.57519C40.5994 8.57519 38.8836 9.1877 37.101 10.4127L35.4297 8.03074C37.5912 6.28393 40.0423 5.41054 42.7831 5.41054C44.8777 5.41054 46.5879 5.94932 47.9137 7.02689C49.2395 8.10447 49.9025 9.80021 49.9025 12.1142V23.7859ZM46.1589 15.517V17.0483C46.1589 18.2053 45.7133 19.124 44.822 19.8046C43.9306 20.4852 42.8889 20.8255 41.6968 20.8255C40.5047 20.8255 39.5744 20.5929 38.9059 20.1279C38.2374 19.6628 37.9031 18.9879 37.9031 18.1032C37.9031 16.3791 39.2512 15.517 41.9475 15.517H46.1589ZM54.6153 21.506C54.6153 20.8028 54.8548 20.2073 55.3339 19.7195C55.813 19.2318 56.3979 18.9879 57.0887 18.9879C57.7794 18.9879 58.3699 19.2318 58.8602 19.7195C59.3504 20.2073 59.5955 20.8028 59.5955 21.506C59.5955 22.2093 59.3504 22.8105 58.8602 23.3095C58.3699 23.8086 57.7794 24.0582 57.0887 24.0582C56.3979 24.0582 55.813 23.8086 55.3339 23.3095C54.8548 22.8105 54.6153 22.2093 54.6153 21.506ZM70.5921 24.0582C72.5084 24.0582 74.0793 23.5421 75.3049 22.5099C76.5305 21.4777 77.1432 20.0995 77.1432 18.3754C77.1432 16.6513 76.5416 15.3809 75.3383 14.5642C74.7367 14.1559 74.1741 13.8383 73.6504 13.6114C73.1268 13.3846 72.5864 13.1804 72.0293 12.9989C71.4723 12.8174 70.8316 12.6359 70.1074 12.4544C69.3832 12.273 68.8206 12.0801 68.4195 11.876C67.8401 11.6037 67.5505 11.1727 67.5505 10.5829C67.5505 9.92499 67.829 9.43158 68.3861 9.10263C68.9432 8.77369 69.6673 8.60922 70.5587 8.60922C72.2522 8.60922 73.8231 9.09696 75.2715 10.0724L76.6753 7.24808C74.8481 6.02305 72.9095 5.41054 70.8595 5.41054C68.8094 5.41054 67.1438 5.91529 65.8625 6.92481C64.5813 7.93433 63.9407 9.27844 63.9407 10.9572C63.9407 13.3392 65.7901 15.0406 69.4891 16.0615C69.5782 16.0842 69.7119 16.1295 69.8902 16.1976C72.2522 16.9235 73.4332 17.7402 73.4332 18.6476C73.4332 19.2602 73.188 19.7649 72.6978 20.1619C72.2076 20.5589 71.5391 20.7574 70.6924 20.7574C68.7537 20.7574 66.7483 19.9634 64.676 18.3754L62.8711 21.3359C63.9407 22.198 65.1718 22.8672 66.5645 23.3436C67.9571 23.82 69.2997 24.0582 70.5921 24.0582ZM89.4768 5.41054C91.9057 5.41054 93.9222 6.09677 95.5266 7.46926C97.131 8.84176 97.9443 10.6282 97.9666 12.8288L98 12.8968L85.0314 18.4435C86.1901 19.8954 87.7666 20.6213 89.7609 20.6213C91.7552 20.6213 93.3986 19.8273 94.691 18.2393L96.897 20.7234C94.7801 22.9466 92.2845 24.0582 89.41 24.0582C86.892 24.0582 84.7306 23.2075 82.9257 21.506C81.1207 19.8046 80.2183 17.5587 80.2183 14.7684C80.2183 12.8401 80.6862 11.1444 81.6221 9.68112C82.558 8.21789 83.7167 7.14033 85.0982 6.44841C86.4798 5.75649 87.9393 5.41054 89.4768 5.41054ZM83.8615 15.483C83.8392 15.3469 83.8281 15.1314 83.8281 14.8364C83.8281 12.9762 84.4353 11.5243 85.6497 10.4808C86.8642 9.43724 88.2067 8.91548 89.6774 8.91548C91.616 8.91548 92.9641 9.6641 93.7217 11.1614L83.8615 15.483Z",
    fill: "currentColor"
  }));
},
    De = function De(_ref4) {
  var e = _ref4.icon,
      t = _ref4.fill,
      n = _ref4.size,
      r = _ref4.stroke,
      o = _ref4.width,
      l = _ref4.height,
      a = _ref4.className,
      i = _ref4.spin,
      s = _ref4.pulse,
      c = _ref4.infinite,
      m = _ref4.fast,
      u = _ref4.easeInOut;
  var p = L("Streamline_Icon", {
    Streamline_Icon_Spin: i,
    Streamline_Icon_Animated: i || s,
    Streamline_Icon_Pulse: s,
    Streamline_Animation_Infinite: c,
    Streamline_Animation_Fast: m,
    Streamline_Animation_EaseInOut: u
  }, a);
  return d.createElement(e, {
    stroke: r,
    fill: t,
    width: o || n,
    height: l || n,
    className: p
  });
};

De.defaultProps = {
  size: 24,
  pulse: !1,
  spin: !1,
  fast: !1,
  easeInOut: !1,
  infinite: !1,
  className: null
};

var Te = w(function (e) {
  return m.createElement("svg", i({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, e), m.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, m.createElement("path", {
    d: "M0.500 10.500 A10.000 10.000 0 1 0 20.500 10.500 A10.000 10.000 0 1 0 0.500 10.500 Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M23.5 23.5L17.571 17.571",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}),
    Ie = w(function (e) {
  return m.createElement("svg", i({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, e), m.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, m.createElement("path", {
    d: "M23.535,18.373,12.409,5.8a.5.5,0,0,0-.749,0L.535,18.373",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}),
    $e = w(function (e) {
  return m.createElement("svg", i({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, e), m.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, m.createElement("path", {
    d: "M.541,5.627,11.666,18.2a.5.5,0,0,0,.749,0L23.541,5.627",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}),
    Pe = w(function (e) {
  return m.createElement("svg", i({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, e), m.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, m.createElement("g", null, m.createElement("g", null, m.createElement("path", {
    d: "M.5,6.5v-2a1,1,0,0,1,1-1h2",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), m.createElement("path", {
    d: "M3.5,20.5h-2a1,1,0,0,1-1-1v-2",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), m.createElement("path", {
    d: "M23.5,17.5v2a1,1,0,0,1-1,1h-2",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), m.createElement("path", {
    d: "M20.5,3.5h2a1,1,0,0,1,1,1v2",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), m.createElement("g", null, m.createElement("line", {
    x1: 3.5,
    y1: 7.5,
    x2: 3.5,
    y2: 16.5,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), m.createElement("line", {
    x1: 20.5,
    y1: 7.5,
    x2: 20.5,
    y2: 16.5,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), m.createElement("line", {
    x1: 7.5,
    y1: 7.5,
    x2: 7.5,
    y2: 13.5,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), m.createElement("line", {
    x1: 12.5,
    y1: 7.5,
    x2: 12.5,
    y2: 13.5,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), m.createElement("line", {
    x1: 14.5,
    y1: 7.5,
    x2: 14.5,
    y2: 13.5,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), m.createElement("line", {
    x1: 9.5,
    y1: 7.5,
    x2: 9.5,
    y2: 13.5,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), m.createElement("line", {
    x1: 16.5,
    y1: 7.5,
    x2: 16.5,
    y2: 13.5,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), m.createElement("line", {
    x1: 7.5,
    y1: 16.5,
    x2: 7.5,
    y2: 15.5,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), m.createElement("line", {
    x1: 5.5,
    y1: 7.5,
    x2: 5.5,
    y2: 13.5,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), m.createElement("line", {
    x1: 5.5,
    y1: 16.5,
    x2: 5.5,
    y2: 15.5,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), m.createElement("line", {
    x1: 9.5,
    y1: 16.5,
    x2: 9.5,
    y2: 15.5,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), m.createElement("line", {
    x1: 12.5,
    y1: 16.5,
    x2: 12.5,
    y2: 15.5,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), m.createElement("line", {
    x1: 14.5,
    y1: 16.5,
    x2: 14.5,
    y2: 15.5,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), m.createElement("line", {
    x1: 16.5,
    y1: 16.5,
    x2: 16.5,
    y2: 15.5,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), m.createElement("line", {
    x1: 18.5,
    y1: 7.5,
    x2: 18.5,
    y2: 13.5,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), m.createElement("line", {
    x1: 18.5,
    y1: 16.5,
    x2: 18.5,
    y2: 15.5,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })))));
}),
    We = w(function (e) {
  return m.createElement("svg", i({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, e), m.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, m.createElement("path", {
    d: "M9,6.5V6A5.5,5.5,0,0,1,20,6V23.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M13,10.5a4,4,0,0,0-8,0V11a.5.5,0,0,0,.5.5h7A.5.5,0,0,0,13,11Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M9 16.75L9 14.75",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M9 22.75L9 20.75",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M12.704 16.457L11.939 14.609",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M15 22L14.235 20.152",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M5.296 16.457L6.061 14.609",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M3 22L3.765 20.152",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}),
    Oe = w(function (e) {
  return m.createElement("svg", i({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, e), m.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, m.createElement("g", null, m.createElement("polyline", {
    points: "1.5 23.5 1.5 21.5 22.5 21.5 22.5 23.5",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), m.createElement("line", {
    x1: 2.5,
    y1: 14.5,
    x2: .5,
    y2: 8.5,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), m.createElement("path", {
    d: "M4,14.5v-1a1.36,1.36,0,0,1,1.49-1.35L8,12.4a1.11,1.11,0,0,1,1,1.1v1",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), m.createElement("path", {
    d: "M15,.5h7a.5.5,0,0,1,.5.5V9.5a0,0,0,0,1,0,0h-8a0,0,0,0,1,0,0V1A.5.5,0,0,1,15,.5Z",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), m.createElement("line", {
    x1: 14.5,
    y1: 6.5,
    x2: 22.5,
    y2: 6.5,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), m.createElement("line", {
    x1: 18.5,
    y1: .5,
    x2: 18.5,
    y2: 9.5,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), m.createElement("line", {
    x1: 22.5,
    y1: 3.5,
    x2: 14.5,
    y2: 3.5,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), m.createElement("line", {
    x1: 13.5,
    y1: 9.5,
    x2: 23.5,
    y2: 9.5,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), m.createElement("path", {
    d: "M2.5,14.5h18a1,1,0,0,1,1,1v3a0,0,0,0,1,0,0H2.5a0,0,0,0,1,0,0v-4A0,0,0,0,1,2.5,14.5Z",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), m.createElement("path", {
    d: "M2,18.5H22a.5.5,0,0,1,.5.5v2.5a0,0,0,0,1,0,0H1.5a0,0,0,0,1,0,0V19A.5.5,0,0,1,2,18.5Z",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))));
}),
    qe = w(function (e) {
  return m.createElement("svg", i({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, e), m.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, m.createElement("g", null, m.createElement("path", {
    d: "M5.33,14.62c-2.6-.8-2.64-4.12-4-4.12S0,16.44,3.12,19.91",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), m.createElement("path", {
    d: "M8.92,15.39l-3-.92a.71.71,0,0,0-.84.43l-2,4.36a.9.9,0,0,0,.25,1.07A8.13,8.13,0,0,0,7,21.88",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), m.createElement("path", {
    d: "M18.67,14.62c2.6-.8,2.64-4.12,4-4.12s1.37,5.94-1.76,9.41",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), m.createElement("path", {
    d: "M15.08,15.39l3-.92a.71.71,0,0,1,.84.43l2,4.36a.9.9,0,0,1-.25,1.07A8.13,8.13,0,0,1,17,21.88",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), m.createElement("path", {
    d: "M17,21.56l-1.83-6a.74.74,0,0,0-.69-.58H9.55a.74.74,0,0,0-.69.58L7,21.56a.87.87,0,0,0,.44,1,11.61,11.61,0,0,0,9.06,0A.87.87,0,0,0,17,21.56Z",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), m.createElement("path", {
    d: "M7,13V7a.5.5,0,0,1,.5-.5h9V13",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), m.createElement("path", {
    d: "M16.5,6.5H18a2,2,0,0,1,0,4H16.5",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), m.createElement("path", {
    d: "M9.93.5c-1.5,1.5,1.5,2.5,0,4",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), m.createElement("path", {
    d: "M13.43.5c-1.5,1.5,1.5,2.5,0,4",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))));
}),
    Ge = w(function (e) {
  return m.createElement("svg", i({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, e), m.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, m.createElement("path", {
    d: "M11.500 17.501 A6.000 6.000 0 1 0 23.500 17.501 A6.000 6.000 0 1 0 11.500 17.501 Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M19.5 17.501L17.5 17.501 17.5 14.501",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M9.5,18.5h-8a1,1,0,0,1-1-1V3.5a1,1,0,0,1,1-1h18a1,1,0,0,1,1,1V10",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M5.5 0.501L5.5 5.501",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M15.5 0.501L15.5 5.501",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M0.5 7.501L20.5 7.501",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}),
    Ye = w(function (e) {
  return m.createElement("svg", i({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, e), m.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, m.createElement("defs", null, m.createElement("style", null, ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;}")), m.createElement("title", null, "calendar-home"), m.createElement("polyline", {
    className: "a",
    points: "12.5 16.308 12.5 23.501 21.5 23.501 21.5 16.308"
  }), m.createElement("polyline", {
    className: "a",
    points: "10.5 18.001 17 12.501 23.5 18.001"
  }), m.createElement("path", {
    className: "a",
    d: "M18.5,23.5h-3v-3a1.5,1.5,0,0,1,3,0Z"
  }), m.createElement("path", {
    className: "a",
    d: "M8.5,18.5h-7a1,1,0,0,1-1-1V3.5a1,1,0,0,1,1-1h18a1,1,0,0,1,1,1v9"
  }), m.createElement("line", {
    className: "a",
    x1: 5.5,
    y1: .501,
    x2: 5.5,
    y2: 5.501
  }), m.createElement("line", {
    className: "a",
    x1: 15.5,
    y1: .501,
    x2: 15.5,
    y2: 5.501
  }), m.createElement("line", {
    className: "a",
    x1: .5,
    y1: 7.501,
    x2: 20.5,
    y2: 7.501
  })));
}),
    Ue = w(function (e) {
  return m.createElement("svg", i({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, e), m.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, m.createElement("path", {
    d: "M0.5 0.499L23.5 23.499",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M23.5 0.499L0.5 23.499",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}),
    Je = w(function (e) {
  return m.createElement("svg", i({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, e), m.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, m.createElement("path", {
    d: "M8,6.157A2,2,0,0,1,8,3.328,2,2,0,0,0,8,.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M12,6.157a2,2,0,0,1,0-2.829A2,2,0,0,0,12,.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M16,6.157a2,2,0,0,1,0-2.829A2,2,0,0,0,16,.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M5.500 11.542 A6.5 3 0 1 0 18.500 11.542 A6.5 3 0 1 0 5.500 11.542 Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M18.5,11.542A17.914,17.914,0,0,1,17.335,18.1a1.992,1.992,0,0,1-.53.763A7.121,7.121,0,0,1,12,20.542a7.121,7.121,0,0,1-4.8-1.679,1.981,1.981,0,0,1-.53-.763A17.9,17.9,0,0,1,5.5,11.542",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M18.219,14.886C19.933,15.8,21,17.079,21,18.5c0,2.761-4.029,5-9,5s-9-2.239-9-5c0-1.421,1.067-2.7,2.78-3.614",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M7.526,13.718C7.24,12.516,9.353,11.5,12,11.5s4.76,1.016,4.474,2.218",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}),
    Xe = w(function (e) {
  return m.createElement("svg", i({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, e), m.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, m.createElement("g", null, m.createElement("path", {
    d: "M10.16,12.93A4.29,4.29,0,0,1,6.5,17v2.54h.83a1,1,0,0,1,1,.77l.32,1.44H4.57L3.55,17l1.36-1.53L4.15,13.2l-.09-.78A3.56,3.56,0,0,1,7.62,8.86h5.09a3.19,3.19,0,0,0,3-2.31",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), m.createElement("path", {
    d: "M4.4,10.9A3.88,3.88,0,0,1,.5,7.28,3.58,3.58,0,0,1,.81,5.81",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), m.createElement("path", {
    d: "M18.56,4.43l.22,1a1.12,1.12,0,0,1-1,1.42H16.33a1.12,1.12,0,0,1-1-1.42l.51-2.29a1,1,0,0,1,1-.87H18.3a2.81,2.81,0,0,1,3.05,2h1.13a1,1,0,0,1,1,1.34l-.4,1.19a1,1,0,0,1-.72.66l-2.51.63c.18,3.65-.5,6.13-2.32,7.15L17,19.54h.51a1,1,0,0,1,1,.77l.32,1.44H14.5v-6H11.69",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))));
}),
    Ke = w(function (e) {
  return m.createElement("svg", i({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, e), m.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, m.createElement("defs", null, m.createElement("style", null, ".a{fill:none;stroke:currentcolor;stroke-linecap:round;stroke-linejoin:round;}")), m.createElement("title", null, "envelope"), m.createElement("rect", {
    className: "a",
    x: .5,
    y: 4.5,
    width: 23,
    height: 15,
    rx: 1.5,
    ry: 1.5
  }), m.createElement("polyline", {
    className: "a",
    points: "20.5 8.5 12 14 3.5 8.5"
  }), m.createElement("line", {
    className: "a",
    x1: 3.5,
    y1: 16,
    x2: 7,
    y2: 14
  }), m.createElement("line", {
    className: "a",
    x1: 20.5,
    y1: 16,
    x2: 17,
    y2: 14
  })));
}),
    Qe = w(function (e) {
  return m.createElement("svg", i({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, e), m.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, m.createElement("path", {
    d: "M15.5 8.499L23.5 0.499",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M0.5 23.499L8.5 15.499",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M5.5 23.499L0.5 23.499 0.5 18.499",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M23.5 5.499L23.5 0.499 18.5 0.499",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M15.5 15.499L23.5 23.499",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M0.5 0.499L8.5 8.499",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M0.5 5.499L0.5 0.499 5.5 0.499",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M18.5 23.499L23.5 23.499 23.5 18.499",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}),
    et = w(function (e) {
  return m.createElement("svg", i({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, e), m.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, m.createElement("path", {
    d: "M21.8,2.1A1,1,0,0,0,21,.5H2.981a1,1,0,0,0-.8,1.6L9.989,12.591V22.5a1,1,0,0,0,1.6.8l2-1.5a1,1,0,0,0,.4-.8v-8.41Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}),
    tt = w(function (e) {
  return m.createElement("svg", i({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, e), m.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, m.createElement("path", {
    d: "M13.767 8.111L8.112 13.768",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M15.889 10.232L10.233 15.889",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M10.232,20.132a1.5,1.5,0,1,1-2.12,2.121L1.747,15.889a1.5,1.5,0,0,1,2.121-2.121",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M2.454,12.354a1.5,1.5,0,0,1,2.122-2.122l9.192,9.193a1.5,1.5,0,1,1-2.122,2.122Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M10.232,4.576a1.5,1.5,0,0,1,2.122-2.122l9.192,9.193a1.5,1.5,0,1,1-2.121,2.121Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M6.7,20.839a1.5,1.5,0,0,1-2.122,2.122L1.04,19.425A1.5,1.5,0,0,1,3.161,17.3",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M13.769,3.868a1.5,1.5,0,1,1,2.122-2.121l6.362,6.364a1.5,1.5,0,1,1-2.121,2.122",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M17.305,3.161a1.5,1.5,0,0,1,2.12-2.121l3.536,3.536A1.5,1.5,0,0,1,20.839,6.7",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}),
    nt = w(function (e) {
  return m.createElement("svg", i({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, e), m.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, m.createElement("g", null, m.createElement("g", null, m.createElement("rect", {
    x: .5,
    y: 11.5,
    width: 23,
    height: 8,
    rx: 1,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), m.createElement("line", {
    x1: 3.5,
    y1: 19.5,
    x2: 3.5,
    y2: 23.5,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), m.createElement("line", {
    x1: 20.5,
    y1: 19.5,
    x2: 20.5,
    y2: 23.5,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), m.createElement("g", null, m.createElement("path", {
    d: "M9.25,2.6a5.37,5.37,0,0,0,3.88,1.65,5.46,5.46,0,0,0,2.14-.44",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), m.createElement("circle", {
    cx: 12.05,
    cy: 4.25,
    r: 3.25,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), m.createElement("path", {
    d: "M16.5,11.5a5.37,5.37,0,0,0-9,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })))));
}),
    rt = w(function (e) {
  return m.createElement("svg", i({
    id: "Light",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, e), m.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, m.createElement("defs", null, m.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;}")), m.createElement("title", null, "lift-two-people"), m.createElement("rect", {
    className: "cls-1",
    x: 3,
    y: 6.5,
    width: 18,
    height: 17,
    rx: 1,
    ry: 1
  }), m.createElement("polyline", {
    className: "cls-1",
    points: "5 2.5 7 0.5 9 2.5"
  }), m.createElement("line", {
    className: "cls-1",
    x1: 7,
    y1: .5,
    x2: 7,
    y2: 4.5
  }), m.createElement("polyline", {
    className: "cls-1",
    points: "15 2.5 17 4.5 19 2.5"
  }), m.createElement("line", {
    className: "cls-1",
    x1: 17,
    y1: 4.5,
    x2: 17,
    y2: .5
  }), m.createElement("circle", {
    className: "cls-1",
    cx: 8.502,
    cy: 10.5,
    r: 2
  }), m.createElement("path", {
    className: "cls-1",
    d: "M11,15.5a2.5,2.5,0,0,0-5,0v2H7l.5,4h2l.5-4h1Z"
  }), m.createElement("circle", {
    className: "cls-1",
    cx: 15.502,
    cy: 10.5,
    r: 2
  }), m.createElement("path", {
    className: "cls-1",
    d: "M18,15.5a2.5,2.5,0,1,0-5,0v2h1l.5,4h2l.5-4h1Z"
  })));
}),
    ot = w(function (e) {
  return m.createElement("svg", i({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, e), m.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, m.createElement("path", {
    d: "M12,.71a7.5,7.5,0,0,1,7.5,7.5c0,3.547-5.5,12.381-7.079,14.85a.5.5,0,0,1-.842,0C10,20.592,4.5,11.757,4.5,8.21A7.5,7.5,0,0,1,12,.71Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M9.000 8.210 A3.000 3.000 0 1 0 15.000 8.210 A3.000 3.000 0 1 0 9.000 8.210 Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}),
    lt = w(function (e) {
  return m.createElement("svg", i({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, e), m.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, m.createElement("g", null, m.createElement("path", {
    d: "M19,11.5A4.49,4.49,0,0,1,23.5,16c0,2-2.92,5.88-4,7.31a.58.58,0,0,1-.44.21.55.55,0,0,1-.44-.21c-1.13-1.43-4-5.31-4-7.31A4.49,4.49,0,0,1,19,11.5Z",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), m.createElement("circle", {
    cx: 19,
    cy: 16,
    r: 1.75,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), m.createElement("line", {
    x1: 7.5,
    y1: 5.39,
    x2: 7.5,
    y2: 21.39,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), m.createElement("line", {
    x1: 14.5,
    y1: 10.5,
    x2: 14.5,
    y2: .5,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), m.createElement("path", {
    d: "M12.47,18,7.79,21.29a.48.48,0,0,1-.58,0L.71,16.65a.51.51,0,0,1-.21-.41V1A.48.48,0,0,1,.77.56a.49.49,0,0,1,.52,0L7.5,5.39,14.21.59a.51.51,0,0,1,.58,0l6.5,4.65a.49.49,0,0,1,.21.4V10",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))));
}),
    at = w(function (e) {
  return m.createElement("svg", i({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, e), m.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, m.createElement("path", {
    d: "M8.791,22.292a.5.5,0,0,1-.582,0l-6.5-4.642a.5.5,0,0,1-.209-.407V2.472a.5.5,0,0,1,.791-.407L8.5,6.5l6.709-4.792a.5.5,0,0,1,.582,0l6.5,4.642a.5.5,0,0,1,.209.407V21.528a.5.5,0,0,1-.791.407L15.5,17.5Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M8.5 6.5L8.5 22.386",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M15.5 17.5L15.5 1.614",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}),
    it = w(function (e) {
  return m.createElement("svg", i({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, e), m.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, m.createElement("path", {
    d: "M6.5,17.5a3,3,0,0,1-6,0v-6a3,3,0,0,1,6,0Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M0.5 12.5L2.5 12.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M0.5 14.5L2.5 14.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M0.5 16.5L2.5 16.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M6.5 12.5L4.5 12.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M6.5 14.5L4.5 14.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M6.5 16.5L4.5 16.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M3.5 20.5L3.5 23.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M1.5 23.5L5.5 23.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M15.500 12.500 A4.000 4.000 0 1 0 23.500 12.500 A4.000 4.000 0 1 0 15.500 12.500 Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M19.5 6.5L19.5 8.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M21.5,4.5a2,2,0,0,1-4,0v-3a1,1,0,0,1,1-1h2a1,1,0,0,1,1,1Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M17.500 12.500 A2.000 2.000 0 1 0 21.500 12.500 A2.000 2.000 0 1 0 17.500 12.500 Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M17.5,3.676c-3.18.64-6.135,3-6.135,6.7,0,.7-1.96,3.093-1.86,4.49.032.442.043.789.606.814s1.324-.005,1.324-.005-.034,3.3.747,4.076c.611.611,1.579.736,3.318.728V23.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M23.5,4.642a8.348,8.348,0,0,0-2-.84",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}),
    st = w(function (e) {
  return m.createElement("svg", i({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, e), m.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, m.createElement("path", {
    d: "M21 7L3 7",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M21 12L3 12",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M21 17L3 17",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}),
    ct = w(function (e) {
  return m.createElement("svg", i({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, e), m.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, m.createElement("path", {
    d: "M12 21.5L12 17.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M18,15.5a2.548,2.548,0,0,0,2.392-1.961L21,10.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M6,15.5a2.548,2.548,0,0,1-2.392-1.961L3,10.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M15.5,13.79S18,7,18,5.5C18,3,15.678.786,13.047.547,12.714.517,12.365.5,12,.5s-.714.017-1.047.047C8.322.786,6,3,6,5.5,6,7,8.5,13.79,8.5,13.79",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M11.000 22.500 A1.000 1.000 0 1 0 13.000 22.500 A1.000 1.000 0 1 0 11.000 22.500 Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M16.000 22.500 A1.000 1.000 0 1 0 18.000 22.500 A1.000 1.000 0 1 0 16.000 22.500 Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M6.000 22.500 A1.000 1.000 0 1 0 8.000 22.500 A1.000 1.000 0 1 0 6.000 22.500 Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M7,21.5a6.277,6.277,0,0,1,5-2,6.277,6.277,0,0,1,5,2",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M5,10a.5.5,0,0,1-.5.5h-3A.5.5,0,0,1,1,10a2,2,0,0,1,4,0Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M23,10a.5.5,0,0,1-.5.5h-3A.5.5,0,0,1,19,10a2,2,0,0,1,4,0Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M18,16.5a1,1,0,0,1-1,1H7a1,1,0,0,1-1-1V15.184a1,1,0,0,1,.686-.95A17.1,17.1,0,0,1,12,13.5a17.1,17.1,0,0,1,5.314.734,1,1,0,0,1,.686.95Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}),
    mt = w(function (e) {
  return m.createElement("svg", i({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, e), m.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, m.createElement("g", null, m.createElement("polygon", {
    points: "8.6 15.5 8.1 12.5 6.1 12.5 5.6 15.5 8.6 15.5",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), m.createElement("path", {
    d: "M1,16.22a.48.48,0,0,1,0-.48.5.5,0,0,1,.43-.24H22.79a.49.49,0,0,1,.42.24.48.48,0,0,1,0,.48L22.1,18.5H2.1Z",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), m.createElement("line", {
    x1: .6,
    y1: 10,
    x2: 13.6,
    y2: 10,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), m.createElement("polyline", {
    points: "2.7 23.5 4.1 18.5 2.1 18.5 0.79 23.5",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), m.createElement("polyline", {
    points: "21.49 23.5 20.1 18.5 22.1 18.5 23.4 23.5",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), m.createElement("circle", {
    cx: 19.6,
    cy: 4,
    r: 3.5,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), m.createElement("polyline", {
    points: "19.6 2 19.6 4 21.22 4",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), m.createElement("path", {
    d: "M18.1,11.5h3a.5.5,0,0,1,.5.5v3.5a0,0,0,0,1,0,0h-4a0,0,0,0,1,0,0V12A.5.5,0,0,1,18.1,11.5Z",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), m.createElement("line", {
    x1: 20.1,
    y1: 11.5,
    x2: 20.1,
    y2: 9.5,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), m.createElement("line", {
    x1: 18.1,
    y1: 9.5,
    x2: 19.1,
    y2: 11.5,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), m.createElement("rect", {
    x: .6,
    y: 2.5,
    width: 13,
    height: 10,
    rx: 1,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))));
}),
    dt = w(function (e) {
  return m.createElement("svg", i({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, e), m.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, m.createElement("path", {
    d: "M10.500 7.000 A6.500 6.500 0 1 0 23.500 7.000 A6.500 6.500 0 1 0 10.500 7.000 Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M15.5,10.5v-7h2a2,2,0,0,1,0,4h-2",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M19.44,16.01a2.03,2.03,0,0,1,.06.49v3a1,1,0,0,1-1,1H1.5a1,1,0,0,1-1-1v-3a2,2,0,0,1,2-2h8",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M3,14.5l.347-3.166A2,2,0,0,1,5.34,9.5H7.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M2.500 17.500 A1.000 1.000 0 1 0 4.500 17.500 A1.000 1.000 0 1 0 2.500 17.500 Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M15.500 17.500 A1.000 1.000 0 1 0 17.500 17.500 A1.000 1.000 0 1 0 15.500 17.500 Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M5.5,20.5V22a1.5,1.5,0,0,1-3,0V20.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M17.5,20.5V22a1.5,1.5,0,0,1-3,0V20.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M0.5 12.5L3 14.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}),
    ut = w(function (e) {
  return m.createElement("svg", i({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, e), m.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, m.createElement("path", {
    d: "M9.086,7.4a2.315,2.315,0,0,0,0-3.271L6.632,1.678a2.313,2.313,0,0,0-3.271,0L2.016,3.024a3.463,3.463,0,0,0-.439,4.365A53.778,53.778,0,0,0,16.611,22.423a3.469,3.469,0,0,0,4.366-.437l1.345-1.346a2.312,2.312,0,0,0,0-3.271l-2.453-2.453a2.312,2.312,0,0,0-3.271,0l-.818.818A54.879,54.879,0,0,1,8.268,8.22Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}),
    pt = function pt(e) {
  var t = e,
      n = t.width,
      r = t.height,
      o = t.outer,
      l = t.inner,
      a = t._hover,
      m = t._selected,
      u = c(t, ["width", "height", "outer", "inner", "_hover", "_selected"]);
  var p = void 0 !== a ? {
    ".pin-outer-path": a.outer,
    ".pin-inner-path": a.inner
  } : {},
      h = void 0 !== m ? {
    ".pin-outer-path": m.outer,
    ".pin-inner-path": m.inner
  } : {};
  return d.createElement(w.svg, s(i({
    width: n,
    height: r,
    viewBox: "0 0 24 24"
  }, u), {
    sx: {
      _hover: p,
      _selected: h,
      ".pin-outer-path": o,
      ".pin-inner-path": l
    }
  }), d.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, d.createElement("path", {
    d: "M12,.71a7.5,7.5,0,0,1,7.5,7.5c0,3.547-5.5,12.381-7.079,14.85a.5.5,0,0,1-.842,0C10,20.592,4.5,11.757,4.5,8.21A7.5,7.5,0,0,1,12,.71Z",
    className: "pin-outer-path",
    strokeWidth: "1px",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), d.createElement("path", {
    d: "M9.000 8.210 A3.000 3.000 0 1 0 15.000 8.210 A3.000 3.000 0 1 0 9.000 8.210 Z",
    className: "pin-inner-path",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
},
    ht = w(function (e) {
  return m.createElement("svg", i({
    id: "Light",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, e), m.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, m.createElement("defs", null, m.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;}")), m.createElement("title", null, "real-estate-dimensions-block"), m.createElement("line", {
    className: "cls-1",
    x1: 2.5,
    y1: 23.5,
    x2: 2.5,
    y2: 5.5
  }), m.createElement("polyline", {
    className: "cls-1",
    points: "0.5 21.5 2.5 23.5 4.5 21.5"
  }), m.createElement("polyline", {
    className: "cls-1",
    points: "4.5 7.5 2.5 5.5 0.5 7.5"
  }), m.createElement("line", {
    className: "cls-1",
    x1: 5.5,
    y1: 2.5,
    x2: 23.5,
    y2: 2.5
  }), m.createElement("polyline", {
    className: "cls-1",
    points: "7.5 0.5 5.5 2.5 7.5 4.5"
  }), m.createElement("polyline", {
    className: "cls-1",
    points: "21.5 4.5 23.5 2.5 21.5 0.5"
  }), m.createElement("rect", {
    className: "cls-1",
    x: 7.5,
    y: 7.5,
    width: 16,
    height: 16,
    rx: 1,
    ry: 1
  }), m.createElement("path", {
    className: "cls-1",
    d: "M19.5,23.5V19a.5.5,0,0,1,.5-.5h1"
  }), m.createElement("line", {
    className: "cls-1",
    x1: 23.5,
    y1: 15.5,
    x2: 19.5,
    y2: 15.5
  }), m.createElement("line", {
    className: "cls-1",
    x1: 23.5,
    y1: 12.5,
    x2: 19.5,
    y2: 12.5
  }), m.createElement("path", {
    className: "cls-1",
    d: "M11.5,7.5V12a.5.5,0,0,0,.5.5h4a.5.5,0,0,0,.5-.5V7.5"
  }), m.createElement("path", {
    className: "cls-1",
    d: "M10.5,19.5V16a.5.5,0,0,0-.5-.5H7.5"
  }), m.createElement("line", {
    className: "cls-1",
    x1: 13.5,
    y1: 23.5,
    x2: 13.5,
    y2: 19.5
  }), m.createElement("path", {
    className: "cls-1",
    d: "M16.5,23.5V17a.5.5,0,0,0-.5-.5H13.5"
  })));
}),
    Et = w(function (e) {
  return m.createElement("svg", i({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, e), m.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, m.createElement("path", {
    d: "M15.5,15.5H18a.5.5,0,0,0,.5-.5C18.433,7.2,16.853.5,15.5.5v23",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M5.5.5v5a3,3,0,0,0,6,0V.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M8.501 0.5L8.501 23.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}),
    kt = w(function (e) {
  return m.createElement("svg", i({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, e), m.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, m.createElement("path", {
    d: "M0.5 9.5L23.5 9.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M14.5,5.5h8a1,1,0,0,1,1,1v15a1,1,0,0,1-1,1H1.5a1,1,0,0,1-1-1V6.5a1,1,0,0,1,1-1h8",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M15 14.5L21 14.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M15 17.5L18.5 17.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M12.963,20c-.408-.63-1.761-1.088-3.455-1.715-.478-.178-.4-1.426-.188-1.659a3.524,3.524,0,0,0,.918-2.734A2.188,2.188,0,0,0,8,11.5a2.188,2.188,0,0,0-2.238,2.392,3.524,3.524,0,0,0,.918,2.734c.212.233.29,1.481-.188,1.659C4.8,18.912,3.445,19.37,3.037,20",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M14.5,7a.5.5,0,0,1-.5.5H10A.5.5,0,0,1,9.5,7V4a2.5,2.5,0,0,1,5,0Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}),
    gt = w(function (e) {
  return m.createElement("svg", i({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, e), m.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, m.createElement("path", {
    d: "M0.714 10.353L3.501 14.503 6.706 10.665",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M23.286 14.655L20.501 10.503 17.294 14.342",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M20.464,10.54a8.622,8.622,0,0,1-6.51,9.729,8.493,8.493,0,0,1-7.931-2.224",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M3.505,14.479A8.853,8.853,0,0,1,10.043,3.726a8.493,8.493,0,0,1,8.324,2.642",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}),
    ft = w(function (e) {
  return m.createElement("svg", i({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, e), m.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, m.createElement("path", {
    d: "M.5,11,2,18.5H6.5a1,1,0,0,1,1,1v4",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M2 18.5L1.5 23.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M23.5,11,22,18.5H17.5a1,1,0,0,0-1,1v4",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M22 18.5L22.5 23.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M12 6.5L12 23.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M5.5 14.5L18.5 14.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M22.182,5.534A88.607,88.607,0,0,1,12,.5,88.607,88.607,0,0,1,1.818,5.534.5.5,0,0,0,2,6.5H22a.5.5,0,0,0,.182-.966Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}),
    vt = w(function (e) {
  return m.createElement("svg", i({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, e), m.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, m.createElement("g", null, m.createElement("path", {
    d: "M12,.5A16.58,16.58,0,0,0,.67,4.84a.5.5,0,0,0-.17.38V7a.5.5,0,0,0,.5.5H23a.5.5,0,0,0,.5-.5V5.22a.5.5,0,0,0-.17-.38A16.58,16.58,0,0,0,12,.5Z",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), m.createElement("line", {
    x1: 1.5,
    y1: 7.5,
    x2: 1.5,
    y2: 22,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), m.createElement("line", {
    x1: 22.5,
    y1: 7.5,
    x2: 22.5,
    y2: 22,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), m.createElement("path", {
    d: "M5.5,17.5H12a0,0,0,0,1,0,0v6a0,0,0,0,1,0,0H5.5A.5.5,0,0,1,5,23V18A.5.5,0,0,1,5.5,17.5Z",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), m.createElement("path", {
    d: "M12,17.5h6.5a.5.5,0,0,1,.5.5v5a.5.5,0,0,1-.5.5H12a0,0,0,0,1,0,0v-6A0,0,0,0,1,12,17.5Z",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), m.createElement("path", {
    d: "M9,11.5h6a.5.5,0,0,1,.5.5v5.5a0,0,0,0,1,0,0h-7a0,0,0,0,1,0,0V12A.5.5,0,0,1,9,11.5Z",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), m.createElement("path", {
    d: "M10.5,11.5h3a0,0,0,0,1,0,0V14a.5.5,0,0,1-.5.5H11a.5.5,0,0,1-.5-.5V11.5A0,0,0,0,1,10.5,11.5Z",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), m.createElement("path", {
    d: "M7,17.5h3a0,0,0,0,1,0,0V20a.5.5,0,0,1-.5.5h-2A.5.5,0,0,1,7,20V17.5A0,0,0,0,1,7,17.5Z",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), m.createElement("path", {
    d: "M14,17.5h3a0,0,0,0,1,0,0V20a.5.5,0,0,1-.5.5h-2A.5.5,0,0,1,14,20V17.5A0,0,0,0,1,14,17.5Z",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), m.createElement("line", {
    x1: 10.25,
    y1: 4.5,
    x2: 13.75,
    y2: 4.5,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))));
}),
    Lt = w(function (e) {
  return m.createElement("svg", i({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, e), m.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, m.createElement("path", {
    d: "M12 14.5L12 23.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M9 23.5L15 23.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M5.5,8,6.442.934A.5.5,0,0,1,6.938.5H17.062a.5.5,0,0,1,.5.434L18.5,8a6.5,6.5,0,0,1-13,0Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M5.7 6.5L18.206 6.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}),
    Ct = w(function (e) {
  return m.createElement("svg", i({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, e), m.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, m.createElement("path", {
    d: "M0.500 15.000 A4.000 4.000 0 1 0 8.500 15.000 A4.000 4.000 0 1 0 0.500 15.000 Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M15.500 15.000 A4.000 4.000 0 1 0 23.500 15.000 A4.000 4.000 0 1 0 15.500 15.000 Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M11 15.001L17 9 8.5 9 4.5 15 11 15 6.937 5.313",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M19.5,15l-.947-.32L16.4,6.712a.5.5,0,0,1,.541-.627l2.419.282a1,1,0,0,1-.285,1.981",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M6 5L9 6",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}),
    wt = w(function (e) {
  return m.createElement("svg", i({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, e), m.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, m.createElement("path", {
    d: "M2.250 12.750 A1.750 1.750 0 1 0 5.750 12.750 A1.750 1.750 0 1 0 2.250 12.750 Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M7.123,17.112A3.6,3.6,0,0,0,.5,18",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M18.250 12.750 A1.750 1.750 0 1 0 21.750 12.750 A1.750 1.750 0 1 0 18.250 12.750 Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M16.877,17.112A3.6,3.6,0,0,1,23.5,18",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M10.250 3.250 A1.750 1.750 0 1 0 13.750 3.250 A1.750 1.750 0 1 0 10.250 3.250 Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M15.5,8.5a3.612,3.612,0,0,0-7,0",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M17.749,21.3a1,1,0,0,1-.979,1.2H7.23a1,1,0,0,1-.979-1.2l2.083-10a1,1,0,0,1,.979-.8h5.374a1,1,0,0,1,.979.8Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), m.createElement("path", {
    d: "M14.418,19.929a.5.5,0,0,1-.495.571H10.077a.5.5,0,0,1-.495-.571l.357-2.5A.5.5,0,0,1,10.434,17h3.132a.5.5,0,0,1,.495.429Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}),
    yt = w(function (e) {
  return m.createElement("svg", i({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, e), m.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, m.createElement("g", null, m.createElement("circle", {
    cx: 7.5,
    cy: 7,
    r: 2.5,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), m.createElement("path", {
    d: "M15,23.5l-.22-2.63a1.5,1.5,0,0,0-1.49-1.37H10.35a3.52,3.52,0,0,1-3.48-3.14l-.34-3.09a1.49,1.49,0,0,1,1.2-1.75,1.51,1.51,0,0,1,1.75,1.2c.42,3.72.37,3.28.37,3.32a.52.52,0,0,0,.5.46h2.89a4.54,4.54,0,0,1,4.49,4.12L18,23.49",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), m.createElement("path", {
    d: "M1.5,13.5H3.16a1,1,0,0,1,1,.83l.69,4A4,4,0,0,0,8.74,21.5H12.5l.25,2",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), m.createElement("line", {
    x1: 19,
    y1: .5,
    x2: 19,
    y2: 3,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), m.createElement("path", {
    d: "M15.5,6.5a3.5,3.5,0,0,1,7,0V7a.5.5,0,0,1-.5.5H16a.5.5,0,0,1-.5-.5Z",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))));
}),
    xt = w(function (e) {
  return m.createElement("svg", i({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e), m.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 20.24L8.15299 21.6252L6.38 19.0021L3.22183 18.7782L2.99793 15.62L0.374816 13.847L1.76 11L0.374816 8.15299L2.99793 6.38L3.22183 3.22183L6.38 2.99793L8.15299 0.374816L11 1.76L13.847 0.374816L15.62 2.99793L18.7782 3.22183L19.0021 6.38L21.6252 8.15299L20.24 11L21.6252 13.847L19.0021 15.62L18.7782 18.7782L15.62 19.0021L13.847 21.6252L11 20.24Z",
    fill: "#007AFF"
  }), m.createElement("path", {
    d: "M6.47046 11.1184L9.41535 14.2351L15.5293 7.76452",
    stroke: "white",
    strokeWidth: 2
  }));
}),
    bt = w(function (e) {
  return m.createElement("svg", i({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, e), m.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, m.createElement("path", {
    d: "M5.651,23.5,18.227,12.374a.5.5,0,0,0,0-.748L5.651.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}),
    Nt = w(function (e) {
  return m.createElement("svg", i({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, e), m.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, m.createElement("g", null, m.createElement("line", {
    x1: 7.5,
    y1: 5.39,
    x2: 7.5,
    y2: 21.39,
    style: {
      fill: "none",
      stroke: "#007AFF",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), m.createElement("line", {
    x1: 14.5,
    y1: 10.5,
    x2: 14.5,
    y2: .5,
    style: {
      fill: "none",
      stroke: "#007AFF",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), m.createElement("path", {
    d: "M10.5,19.36,7.79,21.29a.48.48,0,0,1-.58,0L.71,16.65a.51.51,0,0,1-.21-.41V1A.48.48,0,0,1,.77.56a.49.49,0,0,1,.52,0L7.5,5.39,14.21.59a.51.51,0,0,1,.58,0l6.5,4.65a.49.49,0,0,1,.21.4V11.5",
    style: {
      fill: "none",
      stroke: "#007AFF",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), m.createElement("path", {
    d: "M21.5,17A4.5,4.5,0,1,1,17,12.5,4.5,4.5,0,0,1,21.5,17Z",
    style: {
      fill: "none",
      stroke: "#007AFF",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), m.createElement("line", {
    x1: 20.18,
    y1: 20.18,
    x2: 23.5,
    y2: 23.5,
    style: {
      fill: "none",
      stroke: "#007AFF",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))));
}),
    Mt = function Mt(e) {
  var t = e,
      _t$filled = t.filled,
      n = _t$filled === void 0 ? !1 : _t$filled,
      r = c(t, ["filled"]);
  return d.createElement(w.svg, i({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, r), d.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, d.createElement("path", {
    d: "M12,21.932,2.2,11.84A5.667,5.667,0,0,1,1.113,5.233h0A5.839,5.839,0,0,1,10.4,3.746L12,5.205l1.6-1.459a5.84,5.84,0,0,1,9.287,1.487h0A5.669,5.669,0,0,1,21.8,11.84Z",
    fill: n ? "currentColor" : "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var jt = w(function (e) {
  return m.createElement("svg", i({
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e), m.createElement("ellipse", {
    cx: 16.2038,
    cy: 13.5,
    rx: 9.7963,
    ry: 11.5,
    fill: "#7FACFA"
  }), m.createElement("ellipse", {
    cx: 12.7963,
    cy: 13.5,
    rx: 9.7963,
    ry: 11.5,
    fill: "white"
  }), m.createElement("ellipse", {
    cx: 14.5,
    cy: 13.5,
    rx: 9.5,
    ry: 11.5,
    fill: "#D5E1F5"
  }), m.createElement("circle", {
    cx: 14.5,
    cy: 13.5,
    r: 12.5,
    stroke: "#007AFF",
    strokeWidth: 2
  }), m.createElement("line", {
    x1: 27.5858,
    y1: 26.8159,
    x2: 23.4922,
    y2: 22.7223,
    stroke: "#007AFF",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), m.createElement("path", {
    d: "M13.0066 16.162H14.9826V15.516C14.9826 13.179 18.3646 13.331 18.3646 10.196C18.3646 8.011 16.6546 6.7 14.2226 6.7C11.2016 6.7 9.89063 8.733 9.89063 10.88H11.8856C11.8856 9.55 12.5696 8.41 14.2226 8.41C15.4766 8.41 16.2746 9.227 16.2746 10.291C16.2746 12.419 13.0066 12.172 13.0066 15.668V16.162ZM12.8546 20H15.1156V17.72H12.8546V20Z",
    fill: "#007AFF"
  }));
}),
    At = function At(e) {
  return d.createElement(fe, i({
    variant: "square-fill"
  }, e), d.createElement(ze, null));
},
    Ft = function Ft(e) {
  return d.createElement(fe, i({
    variant: "square-fill"
  }, e), d.createElement(Ve, null));
},
    Bt = function Bt(e) {
  var t = e,
      _t$variant2 = t.variant,
      n = _t$variant2 === void 0 ? "horizontal" : _t$variant2,
      r = t.center,
      o = t.spaceBetween,
      l = t.className,
      a = t.children,
      m = c(t, ["variant", "center", "spaceBetween", "className", "children"]);
  return d.createElement("div", s(i({}, m), {
    className: le("grid-container", [{
      "space-between": o,
      center: r
    }, n, l])
  }), a);
},
    St = function St(e) {
  var t = e,
      n = t.children,
      r = c(t, ["children"]);
  return d.createElement(Bt, s(i({}, r), {
    variant: "horizontal"
  }), n);
},
    Zt = function Zt(e) {
  var t = e,
      n = t.children,
      r = c(t, ["children"]);
  return d.createElement(Bt, s(i({}, r), {
    variant: "vertical"
  }), n);
},
    Vt = function Vt(e) {
  var t = e,
      n = t.className,
      r = t.children,
      o = c(t, ["className", "children"]);
  return d.createElement("div", s(i({}, o), {
    className: le("grid-item", n)
  }), r);
},
    _t = function _t(_ref5) {
  var e = _ref5.onLeftClick,
      t = _ref5.onRightClick,
      _ref5$color = _ref5.color,
      n = _ref5$color === void 0 ? "blue" : _ref5$color;
  return d.createElement(St, {
    className: le("button-group", "arrows")
  }, d.createElement(At, {
    color: n,
    action: e
  }), d.createElement(Ft, {
    color: n,
    action: t
  }));
},
    Ht = function Ht(e) {
  return d.createElement(_t, i({}, e));
},
    zt = function zt(e) {
  return d.createElement(_t, i({
    color: "yellow"
  }, e));
},
    Rt = function Rt(e) {
  return d.createElement(fe, i({
    variant: "round-stroke"
  }, e), d.createElement(Ve, null));
},
    Dt = function Dt(e) {
  return d.createElement(fe, i({
    variant: "flat",
    color: "grey"
  }, e));
},
    Tt = function Tt(e) {
  return d.createElement(fe, i({
    variant: "flat",
    color: "dark-grey"
  }, e));
},
    It = function It(e) {
  var t = e,
      n = t.selected,
      r = c(t, ["selected"]);
  var o = n ? "blue" : "dark-blue";
  return d.createElement(fe, i({
    variant: "oval-fill",
    color: o
  }, r));
},
    $t = function $t(_ref6) {
  var e = _ref6.links,
      t = _ref6.activeIndex,
      n = _ref6.action,
      r = _ref6.className;
  return d.createElement(St, {
    className: le("button-group", ["links", r]),
    center: !0
  }, e.map(function (e, r) {
    return r !== t ? d.createElement(Dt, {
      key: e,
      action: function action() {
        return n(r);
      }
    }, e) : d.createElement(Tt, {
      key: e
    }, e);
  }));
},
    Pt = function Pt(e) {
  var t = e,
      n = t.small,
      r = t.className,
      o = c(t, ["small", "className"]);
  return d.createElement(fe, s(i({
    variant: "flat-text"
  }, o), {
    className: L({
      small: !!n
    }, r)
  }));
},
    Wt = function Wt(e) {
  var t = e,
      n = t.action,
      r = t.link,
      o = t.text,
      l = c(t, ["action", "link", "text"]);
  return d.createElement(ve, i({
    action: n,
    link: r
  }, l), o);
},
    Ot = function Ot(e) {
  var t = e,
      n = t.action,
      r = t.link,
      o = t.text,
      l = c(t, ["action", "link", "text"]);
  return d.createElement(Ce, i({
    action: n,
    link: r
  }, l), o);
},
    qt = function qt(_ref7) {
  var e = _ref7.primaryButton,
      t = _ref7.secondaryButton;
  return d.createElement(St, {
    className: le("button-group", "actions")
  }, d.createElement(Wt, i({}, e)), d.createElement(Ot, i({}, t)));
},
    Gt = function Gt(e) {
  var t = e,
      n = t.children,
      r = t.variant,
      o = t.size,
      l = c(t, ["children", "variant", "size"]);
  var a = y("Banner", {
    variant: r,
    size: o
  });
  return d.createElement(x, i({
    __css: a.banner
  }, l), d.createElement(b, {
    value: a
  }, n));
},
    Yt = function Yt(_ref8) {
  var e = _ref8.children;
  var t = N();
  return d.createElement(x, {
    __css: t.avatar
  }, e, d.createElement(x, {
    __css: t.starIconWrapper
  }, d.createElement(xt, {
    __css: t.starIcon
  })));
},
    Ut = function Ut(e) {
  var t = e,
      n = t.children,
      r = c(t, ["children"]);
  var o = N();
  return d.createElement(w.h1, i({
    __css: o.heading
  }, r), n);
},
    Jt = function Jt(e) {
  var t = e,
      n = t.children,
      r = c(t, ["children"]);
  var o = N();
  return d.createElement(w.p, i({
    __css: o.subHeading
  }, r), n);
},
    Xt = function Xt(e) {
  return d.createElement(St, {
    className: "".concat(e.className || "")
  }, d.createElement(Vt, null), d.createElement(Vt, {
    className: "section-maxwidth"
  }, e.children), d.createElement(Vt, null));
},
    Kt = function Kt(_ref9) {
  var e = _ref9.className;
  return d.createElement("svg", {
    width: "169",
    height: "162",
    viewBox: "0 0 169 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: L("shape", e)
  }, d.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.851 1.74237C163.487 13.6732 202.566 105.885 126.446 146.62C50.3265 187.355 -10.1061 137.321 1.41355 110.101C12.9332 82.8814 51.0429 101.154 71.5454 71.5779C92.0478 42.0013 58.2142 -10.1885 110.851 1.74237Z",
    fill: "currentColor"
  }));
},
    Qt = function Qt(_ref10) {
  var e = _ref10.className;
  return d.createElement("svg", {
    width: "134",
    height: "157",
    viewBox: "0 0 134 157",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: L("shape", e)
  }, d.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3938 22.0577C25.4762 39.1827 30.1033 50.9208 18.5207 73.7837C13.1732 84.3391 -2.11248 97.6726 0.245251 120.106C2.51782 141.729 13.4378 157 45.5874 157C77.737 157 128.612 136.518 133.163 106.313C137.715 76.1093 122.553 72.5696 115.092 40.1401C107.63 7.71069 78.2806 0 67.2643 0C56.2481 0 41.3115 4.93262 33.3938 22.0577Z",
    fill: "#ECC11D"
  }));
},
    en = function en(_ref11) {
  var e = _ref11.className;
  return d.createElement("svg", {
    width: "208",
    height: "108",
    viewBox: "0 0 208 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: L("shape", e)
  }, d.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.692 108C191.403 108 211.403 83.2183 207.519 58.0463C203.635 32.8743 182.344 12.2288 150.453 3.30132C118.562 -5.62618 69.3289 4.05479 35.3867 26.2784C1.4445 48.5021 -10.6365 76.2355 10.4527 90.6882C31.5418 105.141 70.761 75.2438 95.9654 82.8377C121.17 90.4316 129.981 108 160.692 108Z",
    fill: "currentColor"
  }));
},
    tn = function tn(_ref12) {
  var e = _ref12.className;
  return d.createElement("svg", {
    width: "134",
    height: "157",
    viewBox: "0 0 134 157",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: L("shape", e)
  }, d.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3938 22.0577C25.4762 39.1827 30.1033 50.9208 18.5207 73.7837C13.1732 84.3391 -2.11248 97.6726 0.245251 120.106C2.51782 141.729 13.4378 157 45.5874 157C77.737 157 128.612 136.518 133.163 106.313C137.715 76.1093 122.553 72.5696 115.092 40.1401C107.63 7.71069 78.2806 0 67.2643 0C56.2481 0 41.3115 4.93262 33.3938 22.0577Z",
    fill: "currentColor"
  }));
},
    nn = function nn(_ref13) {
  var e = _ref13.className;
  return d.createElement("svg", {
    width: "165",
    height: "159",
    viewBox: "0 0 165 159",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: L("shape", e)
  }, d.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.15708 53.5595C-15.5202 95.0816 20.1837 168.618 72.3726 156.76C124.562 144.902 98.058 83.1712 140.871 56.5769C183.683 29.9826 164.356 0.0371704 118.038 0.0371704C71.7203 0.0371704 31.8344 12.0374 8.15708 53.5595Z",
    fill: "currentColor"
  }));
},
    rn = function rn(_ref14) {
  var e = _ref14.className;
  return d.createElement("svg", {
    width: "191",
    height: "120",
    viewBox: "0 0 191 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: L("shape", e)
  }, d.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.745 80.3954C194.446 102.172 194.496 120 162.704 120C130.913 120 92.7133 85.7713 63.5904 97.2011C34.4675 108.631 11.3656 115.223 1.45484 85.7713C-8.45593 56.3194 33.4881 -5.99165 90.1581 0.465891C146.828 6.92343 179.043 58.6183 186.745 80.3954Z",
    fill: "currentColor"
  }));
},
    on = function on(_ref15) {
  var _ref15$variant = _ref15.variant,
      e = _ref15$variant === void 0 ? "horizontal" : _ref15$variant,
      t = _ref15.icon,
      n = _ref15.label,
      r = _ref15.className,
      o = _ref15.children;
  return d.createElement("header", {
    className: le("header", [e, r])
  }, d.createElement(Bt, i({}, {
    variant: e
  }), d.createElement("img", {
    src: t
  }), d.createElement(me, null, n)), o);
},
    ln = function ln(_ref16) {
  var e = _ref16.shape,
      t = _ref16.shapeColor;

  var n = {
    shape2: Kt,
    shape3: Qt,
    shape4: en,
    shape5: tn,
    shape6: nn,
    shape7: rn
  },
      r = function (e) {
    if (!e) return "";
    if (e.indexOf(".") < 0 && e.indexOf("/") < 0) return e;
    var t = e.substring(e.lastIndexOf("/") + 1);
    return t.substring(0, t.indexOf("."));
  }(e),
      o = r && Object.keys(n).includes(r) ? r : Object.keys(n)[Math.floor(Math.random() * Object.keys(n).length)],
      l = n[o];

  return d.createElement(l, {
    className: "".concat(o, " ").concat(t)
  });
},
    an = function an(_ref17) {
  var e = _ref17.shape,
      t = _ref17.shapeColor,
      n = _ref17.icon,
      r = _ref17.label,
      o = _ref17.headline,
      _ref17$color = _ref17.color,
      l = _ref17$color === void 0 ? "blue" : _ref17$color,
      a = _ref17.className;
  return d.createElement(Xt, {
    className: le("section-header", a)
  }, d.createElement(ln, i({}, {
    shape: e,
    shapeColor: t
  })), d.createElement(on, i({
    variant: "vertical"
  }, {
    icon: n,
    label: r
  }), d.createElement(se, {
    color: l
  }, o)));
},
    sn = function sn(e) {
  var t = e,
      n = t.className,
      _t$backgroundColor = t.backgroundColor,
      r = _t$backgroundColor === void 0 ? "white" : _t$backgroundColor,
      o = t.children,
      l = c(t, ["className", "backgroundColor", "children"]);
  return d.createElement("section", s(i({}, l), {
    className: le("section", [r, n])
  }), o);
},
    cn = function cn(e) {
  var t = e,
      n = t.className,
      r = t.children,
      o = c(t, ["className", "children"]);
  return d.createElement(sn, i({
    className: le("page-section", n)
  }, o), r);
},
    mn = function mn(e) {
  var t = e,
      _t$backgroundColor2 = t.backgroundColor,
      n = _t$backgroundColor2 === void 0 ? "white" : _t$backgroundColor2,
      r = t.shapeColor,
      o = t.children,
      l = t.shape,
      a = t.icon,
      m = t.label,
      u = t.headline,
      _t$headlineColor = t.headlineColor,
      p = _t$headlineColor === void 0 ? "blue" : _t$headlineColor,
      h = c(t, ["backgroundColor", "shapeColor", "children", "shape", "icon", "label", "headline", "headlineColor"]);
  return d.createElement(sn, s(i({}, h), {
    backgroundColor: n
  }), d.createElement(an, i({}, {
    shape: l,
    shapeColor: r || "white" == n ? "light-blue" : "white",
    icon: a,
    label: m,
    headline: u,
    color: p
  })), o);
},
    dn = function dn(_ref18) {
  var e = _ref18.variant,
      t = _ref18.imgs,
      n = _ref18.className;
  return d.createElement("div", {
    className: le("image-group", [e, n])
  }, t.map(function (e, t) {
    return d.createElement("img", {
      key: "image-group-".concat(e.slice(0, 12), "_").concat(t),
      src: e
    });
  }));
},
    un = function un(e) {
  return e.imgs.length ? d.createElement(Xt, {
    className: le("section-logos")
  }, d.createElement(dn, i({
    variant: "logos"
  }, e))) : null;
},
    pn = function pn(e) {
  var t = e,
      n = t.color,
      r = t.icon,
      o = t.primaryButton,
      l = t.secondaryButton,
      a = t.children,
      m = t.className,
      u = c(t, ["color", "icon", "primaryButton", "secondaryButton", "children", "className"]);
  var p = o ? l ? d.createElement(ve, {
    action: o.action,
    link: o.link
  }, o.text) : d.createElement(Le, {
    action: o.action,
    link: o.link
  }, o.text) : null,
      h = l ? d.createElement(we, {
    action: l.action,
    link: l.link
  }, l.text) : null;
  return d.createElement("div", s(i({}, u), {
    className: le("section-footer", m)
  }), d.createElement(St, {
    className: "footer-text"
  }, r ? d.createElement("img", {
    src: r
  }) : null, d.createElement(he, {
    color: n,
    center: !0
  }, a)), o || l ? d.createElement(St, {
    center: !0,
    className: "footer-buttons"
  }, p, h) : null);
};

function hn(e) {
  var _u = u(0),
      _u2 = _slicedToArray(_u, 2),
      t = _u2[0],
      n = _u2[1],
      r = t === e.length - 1 ? 0 : t + 1,
      o = 0 === t ? e.length - 1 : t - 1;

  return {
    active: t,
    next: r,
    previous: o,
    goToNext: function goToNext() {
      n(r);
    },
    goToPrevious: function goToPrevious() {
      n(o);
    },
    goToN: function goToN(t) {
      if (t < 0) throw "cannot go lower than 0";
      if (t >= e.length) throw "Attempted to go out of the items array";
      n(t);
    }
  };
}

var En = function En(e) {
  var t = e,
      n = t.items,
      r = t.width,
      o = t.height,
      l = t.className,
      a = t.allowFullScreen,
      s = c(t, ["items", "width", "height", "className", "allowFullScreen"]);

  var _u3 = u(!1),
      _u4 = _slicedToArray(_u3, 2),
      m = _u4[0],
      p = _u4[1],
      _hn = hn(n),
      h = _hn.active,
      E = _hn.goToNext,
      k = _hn.goToPrevious,
      g = n.length > 1,
      f = n.map(function (e, t) {
    return d.createElement("div", {
      key: "carousel_img_".concat(e, "_").concat(t),
      className: L("carousel-item", {
        inactive: t !== h
      })
    }, d.createElement(C, {
      src: e,
      width: m ? 2e3 : r,
      height: m ? 0 : o,
      className: "carousel-img"
    }));
  });

  return d.createElement("div", i({
    className: le("carousel", l, {
      "full-screen": m
    })
  }, s), f, g && d.createElement(d.Fragment, null, d.createElement(At, {
    action: k,
    className: "navigation nav-previous"
  }), d.createElement(Ft, {
    action: E,
    className: "navigation nav-next"
  })), a && d.createElement("a", {
    href: "#",
    onClick: function onClick(e) {
      e.preventDefault(), p(!m);
    },
    className: "full-screen-toggle"
  }, d.createElement(M, {
    as: m ? Ue : Qe,
    h: 6,
    w: 6
  })));
},
    kn = function kn(e) {
  var t = e,
      _t$variant3 = t.variant,
      n = _t$variant3 === void 0 ? "width-auto" : _t$variant3,
      r = t.edgeColor,
      _t$border = t.border,
      o = _t$border === void 0 ? "light" : _t$border,
      l = t.withShadow,
      a = t.className,
      s = t.children,
      m = c(t, ["variant", "edgeColor", "border", "withShadow", "className", "children"]);
  return d.createElement("div", i({
    className: le("card", [n, "".concat(o, "-grey-border"), r ? r + "-left-edge" : "", {
      shadow: l
    }, a])
  }, m), s);
},
    gn = function gn(e) {
  return d.createElement(kn, i({
    edgeColor: "yellow"
  }, e));
},
    fn = function fn(e) {
  return d.createElement(kn, i({
    edgeColor: "green"
  }, e));
},
    vn = function vn(e) {
  var t = e,
      n = t.bg,
      r = t.className,
      o = t.children,
      l = c(t, ["bg", "className", "children"]);
  return d.createElement("div", i({
    className: le("card-block", r, _defineProperty({}, n, !0))
  }, l), o);
},
    Ln = function Ln(e) {
  var t = e,
      n = t.color,
      r = t.size,
      o = t.withIcon,
      l = t.className,
      a = t.children,
      s = c(t, ["color", "size", "withIcon", "className", "children"]);
  return d.createElement(St, i({
    className: le("tag", [n, r, {
      "with-icon": o
    }, l])
  }, s), a);
},
    Cn = function Cn(e) {
  var t = e,
      n = t.testimonial,
      r = t.children,
      o = t.className,
      l = c(t, ["testimonial", "children", "className"]);
  var a = n.logo,
      s = n.size,
      m = n.quote,
      u = n.person,
      p = u.photo,
      h = u.name,
      E = u.title;
  return d.createElement(fn, i({
    variant: "width-md",
    className: L(o, "testimonial-card", {
      centered: !p
    })
  }, l), p ? d.createElement(C, {
    src: p,
    height: 100,
    width: 100,
    className: "face-photo"
  }) : null, d.createElement(he, {
    size: "small",
    italic: !0,
    center: !0,
    className: "quote"
  }, '"', m, '"'), d.createElement(ue, {
    className: "person-name"
  }, h), d.createElement(he, {
    size: "x-small",
    center: !0,
    className: "person-title"
  }, E), d.createElement("img", {
    src: a,
    className: "ts-logo"
  }), d.createElement(Ln, {
    color: "middle-grey"
  }, s), r);
},
    wn = function wn(e) {
  var t = e,
      n = t.proposition,
      r = t.className,
      o = t.children,
      l = c(t, ["proposition", "className", "children"]);
  return d.createElement(gn, i({
    variant: "width-xlg",
    className: L(r, "info-card")
  }, l), d.createElement(on, i({
    variant: "horizontal"
  }, {
    icon: n.icon,
    label: n.label
  }), d.createElement(ce, {
    color: "yellow"
  }, n.headline)), d.createElement(he, null, n.description), o);
},
    yn = function yn(e) {
  var t = e,
      n = t.img,
      r = t.className,
      o = c(t, ["img", "className"]);
  return d.createElement(gn, i({
    variant: "width-lg",
    className: L(r, "img-card")
  }, o), d.createElement(C, {
    src: n,
    height: 535,
    width: 450
  }));
},
    xn = function xn(_ref19) {
  var e = _ref19.expert;
  var t = e.img,
      n = e.fullName,
      r = e.positionTitle;
  return d.createElement(vn, {
    bg: "green",
    className: "header"
  }, d.createElement(C, {
    src: t,
    width: 160,
    height: 160,
    className: "face-photo"
  }), d.createElement(pe, {
    color: "white",
    className: "person-name"
  }, n), d.createElement(Ln, {
    color: "white",
    withIcon: !0
  }, r, d.createElement(_e, null)));
},
    bn = function bn(_ref20) {
  var e = _ref20.expert;
  var t = e.fullName,
      n = e.mail,
      r = e.phone,
      o = e.linkedin;
  return d.createElement(vn, {
    bg: "middle-blue",
    className: "contacts"
  }, r && d.createElement("div", {
    className: "phone"
  }, d.createElement(Ze, null), d.createElement(Pt, s(i({}, {
    link: "tel:".concat(r),
    text: r.slice(0, 3) + " (0) " + r.slice(3)
  }), {
    small: !0
  }))), n && d.createElement("div", {
    className: "email"
  }, d.createElement(Ae, null), d.createElement(Pt, s(i({}, {
    link: "mailto:".concat(n),
    text: n
  }), {
    small: !0
  }))), o && d.createElement("div", {
    className: "linkedin"
  }, d.createElement(Be, null), d.createElement(Pt, s(i({}, {
    link: o,
    text: t
  }), {
    small: !0
  }))));
},
    Nn = function Nn(_ref21) {
  var e = _ref21.variant,
      t = _ref21.expert;
  return d.createElement(vn, {
    bg: "white",
    className: "main"
  }, d.createElement(he, {
    size: "small",
    className: "description"
  }, t.description), "normal" === e && d.createElement(d.Fragment, null, d.createElement(he, {
    size: "small",
    className: "separator"
  }, ". . ."), t.tags.map(function (e) {
    return d.createElement(Ln, {
      key: "tag_".concat(e.replace(" ", "_")),
      color: "dark-blue"
    }, e);
  })));
},
    Mn = function Mn(e) {
  var t = e,
      n = t.variant,
      r = t.expert,
      o = t.className,
      l = c(t, ["variant", "expert", "className"]);
  return d.createElement(kn, i({
    variant: "small" === n ? "width-xsm" : "width-sm",
    className: L(o, "expert-card ".concat(n)),
    withShadow: !0
  }, l), d.createElement(xn, i({}, {
    expert: r
  })), d.createElement(Nn, i({}, {
    expert: r,
    variant: n
  })), "small" === n && d.createElement(bn, {
    expert: r
  }));
},
    jn = function jn(e) {
  return d.createElement(Mn, i({
    variant: "normal"
  }, e));
},
    An = function An(e) {
  return d.createElement(Mn, i({
    variant: "small"
  }, e));
},
    Fn = [[-1, "previous"], [0, "first"], [1, "second"], [2, "third"], [3, "next"]],
    Bn = function Bn(e) {
  var t = e,
      _t$experts = t.experts,
      n = _t$experts === void 0 ? [] : _t$experts,
      r = t.className,
      o = c(t, ["experts", "className"]);

  var _hn2 = hn(n),
      l = _hn2.active,
      a = _hn2.goToNext,
      s = _hn2.goToPrevious;

  function m(e) {
    var t = n.length;
    var r = l + e;

    for (; r < 0 || r >= t;) {
      r < 0 ? r = t + r : r -= t;
    }

    return r;
  }

  function u(e) {
    var _iterator3 = _createForOfIteratorHelper(Fn),
        _step3;

    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var _step3$value = _slicedToArray(_step3.value, 2),
            _t2 = _step3$value[0],
            _n2 = _step3$value[1];

        if (m(_t2) === e) return _n2;
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }

    return "hidden";
  }

  var p = n.map(function (e, t) {
    return d.createElement(jn, {
      key: t,
      expert: e,
      className: u(t)
    });
  });
  return d.createElement("div", i({
    className: le("exp-main-content", r)
  }, o), p, d.createElement(At, {
    action: s,
    className: "navigation nav-previous"
  }), d.createElement(Ft, {
    action: a,
    className: "navigation nav-next"
  }));
},
    Sn = function Sn(e) {
  var t = e,
      n = t.elements,
      r = t.illustration,
      o = t.legend,
      l = t.legendIcon,
      a = t.className,
      s = c(t, ["elements", "illustration", "legend", "legendIcon", "className"]);
  var m = n.map(function (e, t) {
    return d.createElement("li", {
      key: "".concat(e.heading.replace(" ", "").slice(0, 12), "_").concat(t)
    }, d.createElement(Me, null), d.createElement("h3", null, e.heading), d.createElement(he, null, e.description));
  });
  return d.createElement(Xt, i({}, s), d.createElement("div", {
    className: le("ol-section", a)
  }, d.createElement("div", {
    className: "left-side"
  }, d.createElement(yn, {
    img: r
  }), d.createElement("div", {
    className: "legend"
  }, d.createElement("img", {
    src: l,
    className: "legend-icon"
  }), d.createElement(he, {
    className: "legend-text"
  }, o))), d.createElement("ol", {
    className: "right-side"
  }, m)));
},
    Zn = function Zn(e) {
  var t = e,
      n = t.testimonials,
      r = t.className,
      o = c(t, ["testimonials", "className"]);

  var _hn3 = hn(n),
      l = _hn3.active,
      a = _hn3.previous,
      s = _hn3.next,
      m = _hn3.goToN,
      u = _hn3.goToNext,
      p = _hn3.goToPrevious,
      h = n.length > 1,
      E = n.map(function (e, t) {
    return d.createElement(Cn, {
      key: "tscard_".concat(e.name, "_").concat(t),
      testimonial: e,
      className: t === l ? "active" : "inactive"
    }, h && d.createElement(Ht, {
      onRightClick: u,
      onLeftClick: p
    }));
  }),
      k = (h ? [a, l, s] : [l]).map(function (e) {
    return d.createElement(C, {
      key: "tscard_image_".concat(n[e].name, "_").concat(e),
      src: n[e].illustration,
      width: 1080,
      height: 600,
      sizeSet: {
        "320w": {
          width: 600,
          height: 600
        },
        "650w": {
          width: 800,
          height: 600
        },
        "800w": {
          width: 1080,
          height: 600
        }
      },
      className: L("bg-illustration", {
        inactive: e !== l
      })
    });
  });

  return d.createElement("div", i({
    className: le("content-carousel testimonials", r)
  }, o), d.createElement("div", {
    className: "box"
  }, k, E), h && d.createElement($t, {
    links: n.map(function (e) {
      return e.name;
    }),
    activeIndex: l,
    action: m
  }));
},
    Vn = function Vn(e) {
  var t = e,
      n = t.propositions,
      r = t.className,
      o = c(t, ["propositions", "className"]);

  var _hn4 = hn(n),
      l = _hn4.active,
      a = _hn4.next,
      s = _hn4.previous,
      m = _hn4.goToN,
      u = _hn4.goToNext,
      p = _hn4.goToPrevious,
      h = n.length > 1,
      E = n.map(function (e, t) {
    return d.createElement(wn, {
      key: "".concat(e.label.replace(" ", ""), "_").concat(t),
      proposition: e,
      className: t === l ? "active" : "inactive"
    }, h && d.createElement(zt, {
      onRightClick: u,
      onLeftClick: p
    }));
  }),
      k = (h ? [s, l, a] : [l]).map(function (e) {
    var t = n[e];
    return d.createElement(C, {
      key: "vp_img_".concat(t.label.replace(" ", ""), "_").concat(e),
      src: t.illustration,
      width: 1080,
      height: 600,
      sizeSet: {
        "320w": {
          width: 600,
          height: 600
        },
        "650w": {
          width: 800,
          height: 600
        },
        "800w": {
          width: 1080,
          height: 600
        }
      },
      className: L("bg-illustration", {
        inactive: e !== l
      })
    });
  });

  return d.createElement("div", i({
    className: le("content-carousel solutions", r)
  }, o), d.createElement("div", {
    className: "box"
  }, k, E), h && d.createElement($t, {
    links: n.map(function (e) {
      return e.name;
    }),
    activeIndex: l,
    action: m
  }));
},
    _n = function _n(e) {
  var t = e,
      n = t.button,
      r = t.expert,
      o = t.onClickPhone,
      l = t.onClickEmail,
      a = t.description,
      m = t.className,
      u = c(t, ["button", "expert", "onClickPhone", "onClickEmail", "description", "className"]);
  return d.createElement("div", i({
    className: le("single-expert", m)
  }, u), d.createElement(C, {
    src: r.img,
    width: 160,
    height: 160,
    className: "face-photo"
  }), d.createElement("div", {
    className: "name-title"
  }, d.createElement(pe, {
    color: "blue",
    className: "person-name"
  }, r.fullName), d.createElement(he, {
    size: "x-small",
    color: "dark-blue"
  }, r.positionTitle)), n && d.createElement(ve, i({}, n)), d.createElement("div", {
    className: "divider"
  }, ". . ."), d.createElement("div", {
    className: "tags"
  }, r.tags.map(function (e) {
    return d.createElement(Ln, {
      key: "tag_".concat(e.replace(" ", "_")),
      color: "dark-blue"
    }, e);
  })), r.phone ? d.createElement("div", {
    className: "phone"
  }, d.createElement(Ze, null), d.createElement(Pt, s(i({}, {
    link: "tel:".concat(r.phone),
    text: r.phone.slice(0, 3) + " (0) " + r.phone.slice(3),
    action: function action() {
      return o && o();
    }
  }), {
    color: "dark-grey"
  }))) : null, d.createElement("div", {
    className: "email"
  }, d.createElement(Ae, null), d.createElement(Pt, s(i({}, {
    link: "mailto:".concat(r.mail),
    text: r.mail,
    action: function action() {
      return l && l();
    }
  }), {
    color: "dark-grey"
  }))), d.createElement("div", {
    className: "description"
  }, d.createElement(pe, null, a.heading), d.createElement(he, null, a.text)));
},
    Hn = {
  tables: !0,
  simpleLineBreaks: !0
},
    zn = p(function (e) {
  var t = e,
      n = t.className,
      r = t.children,
      o = t.converterOptions,
      l = t.content,
      a = c(t, ["className", "children", "converterOptions", "content"]);
  var m = h(function () {
    return new q.Converter(o || Hn);
  }, [o]).makeHtml(l.replace(/\n( |\t)+/g, "\n"));
  return d.createElement("div", s(i({
    className: le("markdown-content", n)
  }, a), {
    dangerouslySetInnerHTML: {
      __html: m
    }
  }), r);
}),
    Rn = function Rn(e) {
  var t = e,
      n = t.children,
      r = t.className,
      o = c(t, ["children", "className"]);
  return d.createElement("div", i({
    className: le("cards-content", r)
  }, o), d.createElement("div", {
    className: "wrapper"
  }, n));
},
    Dn = function Dn(e) {
  var t = e,
      _t$members = t.members,
      n = _t$members === void 0 ? [] : _t$members,
      r = c(t, ["members"]);
  return d.createElement(Rn, i({}, r), n.map(function (e) {
    return d.createElement(An, {
      key: e.fullName,
      expert: e
    });
  }));
},
    Tn = function Tn(e) {
  var t = e,
      n = t.className,
      r = t.onAccept,
      o = t.onDecline,
      l = c(t, ["className", "onAccept", "onDecline"]);
  return d.createElement("div", i({
    className: le("consent", n)
  }, l), d.createElement(Re, null), d.createElement(he, {
    className: "content-text"
  }, "yta.se använder cookies för att ge dig den bästa upplevelsen av hemsidan och samla in statistik kring hur hemsidan används. Denna samlas i aggregerad form och görs därmed anonym såvida inte annat samtycke ges. Vi använder cookies för att:", d.createElement("ul", null, d.createElement("li", null, "Utveckla våra tjänster och vårt erbjudande till dig"), d.createElement("li", null, "Se till att hemsidan alltid fungerar som den ska och ge dig den bästa möjliga upplevelsen"), d.createElement("li", null, "Hålla hemsidan säker från intrång och förhindra missbruk av våra tjänster")), d.createElement("div", null, d.createElement("a", {
    href: "/data-policy"
  }, "Läs mer"))), d.createElement(St, {
    className: "consent-buttons"
  }, d.createElement(we, {
    action: function action(e) {
      e.preventDefault(), o && o();
    }
  }, "Avböj"), d.createElement(ve, {
    action: function action(e) {
      e.preventDefault(), r && r();
    }
  }, "Godkänn")));
},
    In = function In(_ref22) {
  var e = _ref22.img,
      _ref22$height = _ref22.height,
      t = _ref22$height === void 0 ? 400 : _ref22$height,
      n = _ref22.className;
  return d.createElement(C, {
    className: le("full-width-image", n),
    src: e,
    width: 1080,
    height: t,
    sizeSet: {
      "320w": {
        width: 600,
        height: t
      },
      "650w": {
        width: 800,
        height: t
      },
      "800w": {
        width: 1080,
        height: t
      }
    }
  });
},
    $n = function $n(e) {
  var t = e,
      n = t.variant,
      r = t.icon,
      o = t.primaryButton,
      l = t.className,
      a = t.children,
      s = c(t, ["variant", "icon", "primaryButton", "className", "children"]);
  return d.createElement(St, i({
    className: le("tooltip", [n, "".concat(r.pos, "-icon"), l])
  }, s), d.createElement(Vt, null), d.createElement(Vt, {
    className: "box"
  }, d.createElement("img", {
    src: r.url,
    alt: "tooltip icon",
    className: "icon"
  }), o ? d.createElement(St, {
    spaceBetween: !0
  }, d.createElement(he, null, a), d.createElement(ve, i({}, o), o.text)) : d.createElement(he, {
    center: !0
  }, a)), d.createElement(Vt, null));
},
    Pn = function Pn(e) {
  var t = e,
      _t$variation = t.variation,
      n = _t$variation === void 0 ? "rounded" : _t$variation,
      r = t.onValueChange,
      o = t.label,
      l = t.value,
      a = t.errors,
      s = t.filled,
      m = t.isPristine,
      p = t.className,
      h = t.placeholder,
      E = t.adornment,
      k = c(t, ["variation", "onValueChange", "label", "value", "errors", "filled", "isPristine", "className", "placeholder", "adornment"]);

  var _u5 = u(!1),
      _u6 = _slicedToArray(_u5, 2),
      g = _u6[0],
      f = _u6[1];

  return d.createElement("div", {
    className: le("input-wrapper", p, n, {
      pristine: m,
      focused: g
    })
  }, o ? d.createElement("label", {
    htmlFor: k.name
  }, o) : null, d.createElement("div", {
    className: "positioning-wrapper"
  }, d.createElement("input", i({
    className: le("input", n, {
      invalid: !m && a && a.length,
      filled: s
    }),
    onChange: function onChange(e) {
      e.preventDefault, r(e.target.value);
    },
    value: l,
    placeholder: h || o,
    onFocus: function onFocus() {
      return f(!0);
    },
    onBlur: function onBlur() {
      return f(!1);
    }
  }, k)), E ? d.createElement("span", {
    className: "adornment"
  }, E) : null), !m && a && a.length ? d.createElement("div", {
    className: le("input-error-message")
  }, a[0]) : null);
},
    Wn = function Wn(e) {
  return d.createElement(Pn, i({
    variation: "rounded"
  }, e));
},
    On = function On(e) {
  return d.createElement(Pn, i({
    variation: "squared"
  }, e));
};

var qn = function qn(e) {
  var t = e,
      n = t.option,
      r = t.className,
      o = c(t, ["option", "className"]);
  return d.createElement("li", i({
    onClick: function onClick(e) {
      return n.onClick && n.onClick(e);
    },
    className: L("option", r)
  }, o), n.display);
},
    Gn = function Gn(e) {
  var t = e,
      n = t.variation,
      r = t.options,
      o = t.className,
      l = c(t, ["variation", "options", "className"]);
  return d.createElement(kn, i({
    withShadow: !0,
    border: "medium",
    className: le("options-list", o, n)
  }, l), d.createElement("ul", null, r.map(function (e, t) {
    return d.createElement(qn, {
      key: "menuitem_".concat(t),
      option: e
    });
  })));
};

function Yn(e) {
  var _u7 = u(e),
      _u8 = _slicedToArray(_u7, 2),
      t = _u8[0],
      n = _u8[1];

  return E(function () {
    if (!t) return;

    var e = function e() {
      n(!1);
    };

    return window.addEventListener("click", e), function () {
      window.removeEventListener("click", e);
    };
  }, [t]), {
    toggled: t,
    onClickToggle: function onClickToggle(e) {
      e.preventDefault(), n(!t);
    }
  };
}

var Un = function Un(_ref23) {
  var e = _ref23.control,
      _ref23$withArrow = _ref23.withArrow,
      t = _ref23$withArrow === void 0 ? !1 : _ref23$withArrow,
      n = _ref23.content,
      r = _ref23.value,
      _ref23$disabled = _ref23.disabled,
      o = _ref23$disabled === void 0 ? !1 : _ref23$disabled,
      _ref23$position = _ref23.position,
      l = _ref23$position === void 0 ? "left" : _ref23$position,
      a = _ref23.className,
      i = _ref23.onOpen,
      s = _ref23.onClose,
      c = _ref23.callback;

  var _Yn = Yn(!1),
      m = _Yn.toggled,
      u = _Yn.onClickToggle;

  E(function () {
    m ? i && i() : s && s();
  }, [s, i, m]);
  var p = d.cloneElement(n, {
    className: le("dropdown-content", "align-".concat(l), n.props.className),
    key: "dropdown-content"
  }),
      h = d.cloneElement(e, {
    className: le("dropdown-control", e.props.className, {
      focused: m
    }),
    onClick: function onClick(e) {
      c ? c(e, u) : u(e);
    },
    children: [e.props.children, d.createElement("span", {
      className: "dropdown-display-value",
      key: "dropdown-value"
    }, r), t ? d.createElement("span", {
      className: "adornment",
      key: "control-adornment"
    }, d.createElement(Ne, {
      direction: m ? "up" : "down",
      size: 12
    })) : null]
  });
  return d.createElement("div", {
    className: le("dropdown-wrapper", a, {
      toggled: m,
      disabled: o
    })
  }, h, p);
},
    Jn = function Jn(e) {
  var t = e,
      n = t.onValueChange,
      _t$variation2 = t.variation,
      r = _t$variation2 === void 0 ? " rounded" : _t$variation2,
      o = t.name,
      l = t.value,
      a = t.options,
      s = t.className,
      m = t.placeholder,
      u = t.id,
      p = t.isPristine,
      h = c(t, ["onValueChange", "variation", "name", "value", "options", "className", "placeholder", "id", "isPristine"]);
  var E = a.find(function (e) {
    return e.value === l;
  }),
      k = E ? E.display : m,
      g = a.map(function (_ref24) {
    var e = _ref24.value,
        t = _ref24.display;
    return d.createElement("option", {
      key: e,
      value: e
    }, t);
  }),
      f = a.map(function (_ref25) {
    var e = _ref25.value,
        t = _ref25.display;
    return d.createElement("li", {
      key: e
    }, d.createElement("a", {
      href: "#",
      onClick: function onClick(t) {
        t.preventDefault(), n(e);
      }
    }, t));
  });
  return d.createElement(Un, i({
    className: le("single-select", r, s),
    callback: function callback(e, t) {
      window.matchMedia("(max-width: 39rem)").matches ? e.preventDefault() : t(e);
    },
    control: d.createElement("div", {
      className: le("input", r, {
        "current-value": !0,
        filled: !!l
      })
    }, d.createElement("select", i({
      id: u || o,
      name: o,
      className: le("native-only-select", s),
      onChange: function onChange(e) {
        return n(e.target.value);
      },
      value: l
    }, h), g), d.createElement("ul", null, f)),
    withArrow: !0,
    content: d.createElement(Gn, {
      variation: "monolith",
      options: a,
      className: "dropdown-content"
    }),
    value: k
  }, h));
},
    Xn = function Xn(_ref26) {
  var e = _ref26.onValueChange,
      t = _ref26.value,
      n = _ref26.options,
      r = _ref26.className;
  var o = t,
      l = n.map(function (_ref27) {
    var t = _ref27.value,
        n = _ref27.display;
    return d.createElement("li", {
      key: t
    }, d.createElement(It, {
      action: function action() {
        return function (t) {
          var n = o.slice(),
              r = o.indexOf(t);
          r > -1 ? n.splice(r, 1) : n.push(t), e(n);
        }(t);
      },
      selected: o.indexOf(t) > -1
    }, n));
  });
  return d.createElement("ul", {
    className: le("inline-multi-choice", {
      className: r
    })
  }, l);
},
    Kn = function Kn(e) {
  var t = e,
      n = t.placeholder,
      r = t.options,
      o = t.name,
      l = t.value,
      a = t.onValueChange,
      s = t.className,
      m = t.isPristine,
      u = c(t, ["placeholder", "options", "name", "value", "onValueChange", "className", "isPristine"]);
  var p = r.filter(function (e) {
    return l.indexOf(e.value) > -1;
  }).map(function (e) {
    return e.display;
  }).join(", "),
      h = r.map(function (_ref28) {
    var e = _ref28.value,
        t = _ref28.display;
    return d.createElement("option", {
      key: e,
      value: e
    }, t);
  });
  return d.createElement("span", {
    className: le("input", {
      filled: l.length > 0
    }, "multi-choice-value")
  }, p || n, d.createElement("select", i({
    id: o,
    name: o,
    value: l,
    multiple: !0,
    onChange: function onChange(e) {
      var t = Array.from(e.target.options).filter(function (e) {
        return e.selected;
      }).map(function (e) {
        return e.value;
      });
      a(t);
    },
    className: le("native-only-select", s)
  }, u), h));
};

function Qn(e, t) {
  return {
    errors: t.getErrors(e),
    value: t.getValue(e),
    isPristine: t.isPristine(e),
    name: e,
    onValueChange: function onValueChange(n) {
      return t.setValue(e, n);
    }
  };
}

var er = function er(e) {
  var t = e,
      n = t.label,
      r = t.name,
      o = t.options,
      l = t.form,
      a = t.required,
      s = c(t, ["label", "name", "options", "form", "required"]);
  return d.createElement(G, {
    variant: "outlined",
    fullWidth: !0,
    required: a
  }, d.createElement(Y, {
    htmlFor: "".concat(r, "_field-label"),
    shrink: !0,
    key: "label_".concat(r)
  }, n), d.createElement(U, i({
    value: l.getValue(r),
    onChange: function onChange(e) {
      return l.setValue(r, e.target.value);
    },
    name: r,
    id: "".concat(r, "_field-label"),
    label: n
  }, s), o.map(function (e) {
    return d.createElement(J, {
      key: e.value,
      value: e.value
    }, e.display);
  })));
},
    tr = function tr(e) {
  var t = e,
      n = t.label,
      r = t.name,
      o = t.units,
      l = t.form,
      a = t.required,
      s = c(t, ["label", "name", "units", "form", "required"]);
  var m = l.getErrors(r),
      u = o ? {
    endAdornment: d.createElement(K, {
      position: "end"
    }, o ? d.createElement(Q, {
      color: "textSecondary"
    }, o) : null)
  } : void 0;
  return d.createElement(X, i({
    label: n,
    name: r,
    error: !l.isPristine(r) && m && m.length > 0,
    variant: "outlined",
    InputLabelProps: {
      shrink: !0
    },
    fullWidth: !0,
    value: l.getValue(r),
    onChange: function onChange(e) {
      return l.setValue(r, e.target.value);
    },
    InputProps: u,
    required: a,
    helperText: !l.isPristine(r) && m && m.length > 0 ? m[0] : ""
  }, s));
},
    nr = function nr(e) {
  var t = e,
      n = t.children,
      r = c(t, ["children"]),
      o = N();
  return d.createElement(w.label, i({
    __css: o.formlabel
  }, r), n);
},
    rr = function rr() {
  var e = N();
  return d.createElement(w.hr, {
    __css: e.divider
  });
},
    or = function or(e) {
  var t = e,
      n = t.children,
      r = t.variant,
      o = c(t, ["children", "variant"]),
      l = y("BorderedForm", {
    variant: r
  });
  return d.createElement(x, i({
    __css: l.box
  }, o), d.createElement(b, {
    value: l
  }, n));
},
    lr = function lr(e) {
  var t = e,
      n = t.variant,
      r = t.size,
      o = t.children,
      l = t.selected,
      a = c(t, ["variant", "size", "children", "selected"]),
      s = j("TagButton", {
    variant: n,
    size: r,
    selected: l
  });
  return d.createElement(x, i({
    __css: s,
    as: "button"
  }, a), o);
},
    ar = function ar(e) {
  var t = e.options,
      n = e.children;
  return d.createElement(A, {
    direction: "column"
  }, d.createElement(x, {
    display: "flex",
    css: {
      gap: "0.5rem"
    },
    flexWrap: "wrap",
    p: 4
  }, t.map(function (t, n) {
    var r = t.value,
        o = t.display,
        l = e.multiple ? e.selected.includes(t.value) : e.selected === r;
    return d.createElement(lr, {
      key: r,
      size: "sm",
      selected: l,
      onClick: function onClick(t) {
        if (t.preventDefault(), t.stopPropagation(), e.multiple) {
          var _t3 = l ? e.selected.filter(function (e) {
            return e != r;
          }) : [].concat(_toConsumableArray(e.selected), [r]);

          e.onChange(_t3);
        } else e.onChange(r);
      }
    }, o);
  }), n));
},
    ir = function ir(e) {
  var t,
      n = e,
      r = n.placeholder,
      _n$variant = n.variant,
      o = _n$variant === void 0 ? "outline" : _n$variant,
      l = c(n, ["placeholder", "variant"]);
  var a = r,
      s = !0;
  return l.selected.length > 0 && (s = !1, a = Array.isArray(l.selected) ? l.options.filter(function (e) {
    return l.selected.indexOf(e.value) > -1;
  }).map(function (e) {
    return e.display;
  }).join(", ") : (null == (t = l.options.find(function (e) {
    return e.value === l.selected;
  })) ? void 0 : t.display) || ""), d.createElement(F, null, function (_ref29) {
    var e = _ref29.isOpen;
    return d.createElement(d.Fragment, null, d.createElement(B, null, d.createElement(S, {
      variant: o,
      color: s ? "grey.400" : "grey.800",
      fontWeight: s ? "normal" : "semibold",
      justifyContent: "start",
      maxW: 44,
      h: 10,
      rightIcon: e ? d.createElement(Ie, {
        h: 4,
        w: 4,
        color: "black"
      }) : d.createElement($e, {
        h: 4,
        w: 4,
        color: "black"
      })
    }, d.createElement(Z, {
      textOverflow: "ellipsis",
      overflow: "hidden",
      whiteSpace: "nowrap"
    }, a))), d.createElement(V, null, d.createElement(_, null), d.createElement(H, null, d.createElement(ar, i({}, l)))));
  });
},
    sr = function sr(e) {
  var t = e,
      n = t.className,
      r = c(t, ["className"]);
  return d.createElement("span", i({
    className: le("verified-sign", n)
  }, r), d.createElement(Me, null));
},
    cr = function cr(e) {
  var t = e,
      n = t.children,
      r = t.className,
      o = c(t, ["children", "className"]);
  return d.createElement("div", i({
    className: le("conv-form", r)
  }, o), n);
},
    mr = function mr(e) {
  var t = e,
      n = t.messages,
      r = t.photo,
      o = t.className,
      l = t.number,
      a = t.isValid,
      s = t.isVisible,
      m = t.isSubmitted,
      p = t.onValidate,
      h = t.afterAnswer,
      g = t.input,
      f = t.answerPreText,
      v = t.answerPostText,
      _t$scrollToTop = t.scrollToTop,
      w = _t$scrollToTop === void 0 ? !1 : _t$scrollToTop,
      y = c(t, ["messages", "photo", "className", "number", "isValid", "isVisible", "isSubmitted", "onValidate", "afterAnswer", "input", "answerPreText", "answerPostText", "scrollToTop"]);

  var _u9 = u(0),
      _u10 = _slicedToArray(_u9, 2),
      x = _u10[0],
      b = _u10[1];

  E(function () {
    if (!s || x >= n.length) return;
    var e = 0 === x ? 0 : 750,
        t = window.setTimeout(function () {
      b(x + 1);
    }, e);
    return function () {
      window.clearTimeout(t);
    };
  }, [s, x, n]);
  var N = k(null);
  E(function () {
    if (!s || !w || !N.current) return;
    var e = N.current.getBoundingClientRect().top + document.documentElement.scrollTop - 60;
    window.scrollTo({
      top: e,
      left: 0,
      behavior: "smooth"
    });
  }, [s, w]);
  var M = n.map(function (e, t) {
    return d.createElement("p", {
      key: "".concat(e.slice(0, 12), "_").concat(t),
      className: L({
        visible: t < x
      })
    }, e);
  }),
      j = m && a ? d.createElement(sr, {
    className: "button-slot"
  }) : d.createElement(Rt, {
    action: p,
    disabled: !a,
    className: "button-slot"
  });
  return s ? d.createElement("div", i({
    ref: N,
    className: le("conv-form-question", o)
  }, y), d.createElement(C, {
    src: r,
    className: le("conv-profile-photo"),
    height: 50,
    width: 50
  }), d.createElement("div", {
    className: le("conv-form-messages")
  }, M), d.createElement("div", {
    className: le("conv-answer-nb")
  }, l), d.createElement("div", {
    className: le("conv-answer", {
      visible: x >= n.length
    })
  }, d.createElement("div", {
    className: le("conv-answer-text")
  }, d.createElement("span", {
    className: "pre-text"
  }, f), d.createElement("span", {
    className: "input-slot"
  }, g), d.createElement("span", {
    className: "post-text"
  }, v), j), d.createElement("div", null, h))) : null;
},
    dr = function dr(e) {
  var t = e,
      n = t.shape,
      r = t.icon,
      o = t.headline,
      l = t.primaryButton,
      a = t.children,
      s = t.className,
      m = c(t, ["shape", "icon", "headline", "primaryButton", "children", "className"]);
  return d.createElement("div", i({
    className: le("submit-conf", s)
  }, m), d.createElement("img", {
    className: "shape",
    src: n
  }), d.createElement("div", {
    className: "headline"
  }, d.createElement("img", {
    src: r
  }), d.createElement(pe, {
    color: "blue"
  }, o), d.createElement(pn, {
    primaryButton: l,
    color: "blue"
  }, a)));
},
    ur = function ur(_ref30) {
  var e = _ref30.headline,
      t = _ref30.buttonTitle,
      n = _ref30.buttonDisabled,
      r = _ref30.error,
      o = _ref30.onSubmit,
      _ref30$footer = _ref30.footer,
      l = _ref30$footer === void 0 ? null : _ref30$footer,
      a = _ref30.children,
      i = _ref30.className;
  return d.createElement("form", {
    className: le("embed-form", i)
  }, d.createElement(se, {
    color: "blue"
  }, e), d.createElement("div", {
    className: "inputs-container"
  }, a), r ? d.createElement("div", {
    className: "error-message"
  }, r) : null, d.createElement("div", {
    className: "button-container"
  }, d.createElement(ve, {
    className: "submit-button",
    disabled: n,
    action: o
  }, t)), l);
},
    pr = function pr(e) {
  var t = e,
      n = t.label,
      r = t.header,
      _t$color10 = t.color,
      o = _t$color10 === void 0 ? "white" : _t$color10,
      l = t.primaryButton,
      a = t.secondaryButton,
      m = t.className,
      u = c(t, ["label", "header", "color", "primaryButton", "secondaryButton", "className"]);
  return d.createElement("div", i({
    className: le("top-content", [m])
  }, u), d.createElement(he, {
    size: "normal",
    color: o
  }, n), d.createElement(ie, {
    color: o
  }, r), a ? d.createElement(qt, i({}, {
    primaryButton: l,
    secondaryButton: s(i({}, a), {
      color: o
    })
  })) : d.createElement(Le, i({}, l)));
},
    hr = function hr(e) {
  var t = e,
      n = t.backgroundImage,
      r = t.className,
      o = t.children,
      l = c(t, ["backgroundImage", "className", "children"]);
  return d.createElement("div", i({
    className: le("top-hero-section", [r])
  }, l), d.createElement(C, {
    className: "bg-illustration",
    src: n,
    height: 1e3,
    width: 2e3,
    sizeSet: {
      "320w": {
        width: 400,
        height: 570
      },
      "640w": {
        width: 640,
        height: 570
      },
      "1000w": {
        width: 1e3,
        height: 570
      },
      "1500w": {
        width: 1500,
        height: 750
      },
      "2000w": {
        width: 2e3,
        height: 1e3
      }
    }
  }), o);
},
    Er = function Er(_ref31) {
  var e = _ref31.color;
  return d.createElement(Pt, {
    link: "/",
    className: "yta-logo-link",
    color: e
  }, d.createElement(Re, null));
},
    kr = function kr(e) {
  var t = e,
      _t$variant4 = t.variant,
      n = _t$variant4 === void 0 ? "header" : _t$variant4,
      r = t.links,
      _t$color11 = t.color,
      o = _t$color11 === void 0 ? "dark-grey" : _t$color11,
      l = t.primaryButton,
      a = t.secondaryButton,
      m = t.className,
      u = c(t, ["variant", "links", "color", "primaryButton", "secondaryButton", "className"]);

  var _Yn2 = Yn(!1),
      p = _Yn2.toggled,
      h = _Yn2.onClickToggle;

  return d.createElement("header", i({
    className: le("menu", {
      "with-border": "header" == n,
      toggled: p
    }, m, o)
  }, u), d.createElement(Er, {
    color: o
  }), d.createElement(Se, {
    className: "ham-menu-icon",
    onClick: function onClick(e) {
      return h(e);
    }
  }), d.createElement("nav", {
    className: L({
      toggled: p
    })
  }, d.createElement("div", {
    className: "links"
  }, r.map(function (e) {
    var t = e,
        n = t.title,
        r = c(t, ["title"]);
    return d.createElement(Pt, s(i({
      color: o
    }, r), {
      key: n
    }), n);
  })), d.createElement("div", {
    className: "buttons"
  }, d.createElement(qt, i({}, {
    primaryButton: l,
    secondaryButton: s(i({}, a), {
      color: p ? "dark-grey" : o
    })
  })))));
},
    gr = function gr(_ref32) {
  var e = _ref32.title,
      t = _ref32.links;
  return d.createElement(Vt, null, d.createElement(de, null, e), d.createElement("ul", null, t.map(function (e) {
    var t = e,
        n = t.title,
        r = c(t, ["title"]);
    return d.createElement("li", {
      key: n
    }, d.createElement(Pt, s(i({}, r), {
      color: "dark-grey",
      small: !0
    }), n));
  })));
},
    fr = function fr(_ref33) {
  var e = _ref33.info;
  return d.createElement(Vt, {
    className: "company-info"
  }, d.createElement(de, null, "Hitta lokaler. Enkelt."), d.createElement(Le, {
    link: "mailto:".concat(e.email)
  }, "E-mail"), d.createElement(we, {
    link: "tel:".concat(e.phone.replace(/[^+|\d]/g, ""))
  }, e.phone), d.createElement(de, null, "Hitta oss."), d.createElement(St, {
    className: "buttons-social"
  }, d.createElement("a", {
    href: "https://www.facebook.com/ytapunktse",
    target: "_blank",
    rel: "noopener noreferrer"
  }, d.createElement(Fe, null)), d.createElement("a", {
    href: "https://www.twitter.com/ytapunktse",
    target: "_blank",
    rel: "noopener noreferrer"
  }, d.createElement(He, null)), d.createElement("a", {
    href: "https://www.linkedin.com/company/17884774/",
    target: "_blank",
    rel: "noopener noreferrer"
  }, d.createElement(Be, null))));
},
    vr = function vr() {
  var e = new Date().getFullYear();
  return d.createElement(St, {
    spaceBetween: !0,
    className: "copyright-info"
  }, d.createElement("div", null, "Copyright \xA9 ".concat(e, " Objektia AB")), d.createElement("div", null, d.createElement(Pt, {
    link: "/data-policy",
    noFollow: !0,
    color: "dark-grey",
    small: !0
  }, "Personuppgiftspolicy")));
},
    Lr = function Lr(e) {
  var t = e,
      n = t.companyInfo,
      r = t.serpLinks,
      o = t.blogLinks,
      l = t.infoLinks,
      a = t.className,
      s = c(t, ["companyInfo", "serpLinks", "blogLinks", "infoLinks", "className"]);
  return d.createElement("footer", i({
    className: le("footer", a)
  }, s), d.createElement(Vt, null), d.createElement(Zt, {
    className: "box"
  }, d.createElement(Vt, {
    className: "footer-logo"
  }, d.createElement(Re, null)), d.createElement(St, {
    spaceBetween: !0,
    className: "columns"
  }, d.createElement(fr, {
    info: n
  }), d.createElement(gr, {
    title: "Utforska yta.se",
    links: r
  }), d.createElement(gr, {
    title: "Lärocenter",
    links: o
  }), d.createElement(gr, {
    title: "Om yta.se",
    links: l
  })), d.createElement("hr", {
    className: "divider"
  }), d.createElement(vr, null)), d.createElement(Vt, null));
};

function Cr(_ref34) {
  var e = _ref34.content,
      _ref34$showCloseButto = _ref34.showCloseButton,
      t = _ref34$showCloseButto === void 0 ? !0 : _ref34$showCloseButto,
      _ref34$closeOnClickOu = _ref34.closeOnClickOutside,
      n = _ref34$closeOnClickOu === void 0 ? !0 : _ref34$closeOnClickOu,
      r = _ref34.onClose,
      o = _ref34.className;
  var l = k(null);
  var a, i;
  return E(function () {
    function e(e) {
      a.current && a.current.contains(e.target) || i();
    }

    return document.addEventListener("mousedown", e), function () {
      document.removeEventListener("mousedown", e);
    };
  }, [a = l, i = function i() {
    n && r();
  }]), E(function () {
    return e && (document.body.style.overflowY = "scroll", document.body.style.position = "fixed"), function () {
      document.body.style.overflowY = "", document.body.style.position = "";
    };
  }, [e]), e ? d.createElement("aside", {
    className: le("modal-content", o)
  }, d.createElement("div", {
    ref: l,
    className: "wrapper"
  }, t && d.createElement("button", {
    className: "close-button",
    "aria-label": "Close Modal",
    onClick: r
  }, d.createElement("span", null, "Close"), d.createElement("svg", {
    viewBox: "0 0 40 40"
  }, d.createElement("path", {
    d: "M 10,10 L 30,30 M 30,10 L 10,30"
  }))), d.createElement("div", {
    className: "body"
  }, d.createElement("div", {
    className: "scroll-control"
  }, e)))) : null;
}

var wr = function wr(_ref35) {
  var e = _ref35.color,
      t = _ref35.kind;
  var n = {};
  return "fill" == t ? n.background = e : n.border = "2px solid ".concat(e), d.createElement("div", {
    style: n,
    className: le("map-legend-item")
  });
},
    yr = function yr(_ref36) {
  var e = _ref36.children;
  return d.createElement("ul", {
    className: le("map-legend")
  }, e);
},
    xr = function xr(e) {
  var t = e,
      n = t.children,
      r = t.className,
      o = c(t, ["children", "className"]);
  return d.createElement(te, i({
    className: le("map-popup", r)
  }, o), n);
};

var br = function br(_ref37) {
  var e = _ref37.id,
      t = _ref37.stripeSize,
      n = _ref37.spacing,
      r = _ref37.stripeColor,
      o = _ref37.bgColor,
      l = _ref37.children;

  var _g = g(ne),
      a = _g.map,
      i = h(function () {
    return function (e, t, n, r) {
      var o = e + t,
          l = new Uint8Array(o * o * 4);

      for (var _a = 0; _a < o; _a++) {
        for (var _t4 = 0; _t4 < o; _t4++) {
          var _i = 4 * (_t4 * o + _a),
              _s = _a + _t4 < e || _a + _t4 >= o && _a + _t4 < o + e ? n : r;

          l[_i + 0] = _s[0], l[_i + 1] = _s[1], l[_i + 2] = _s[2], l[_i + 3] = _s[3];
        }
      }

      return l;
    }(t, n, r, o);
  }, [t, n, r, o]),
      s = t + n;

  return E(function () {
    var t = {
      width: s,
      height: s,
      data: i
    };
    return a.hasImage(e) ? a.updateImage(e, t) : a.addImage(e, t), function () {
      a.removeImage(e);
    };
  }, [i, e, s, a]), d.createElement(d.Fragment, null, l);
},
    Nr = function Nr(e) {
  var t = e,
      n = t.children,
      r = c(t, ["children"]);
  var o = {
    display: "grid",
    pt: 6,
    pb: 8,
    border: "1px",
    borderColor: "transparent",
    borderTopColor: "grey.100",
    gridTemplateColumns: {
      base: "1fr",
      md: "25rem 1fr"
    },
    gridTemplateRows: {
      base: "auto auto auto",
      md: "auto auto"
    },
    gridTemplateAreas: {
      base: "'header' 'illustration' 'actions'",
      md: "'illustration header' 'illustration actions'"
    },
    gridRowGap: {
      base: 3,
      md: 0
    },
    gridColumnGap: {
      base: 0,
      md: 10
    },
    _hover: {
      px: {
        base: 1,
        md: "20px",
        lg: "40px"
      },
      mx: {
        base: -1,
        md: "-20px",
        lg: "-40px"
      },
      borderColor: "blue.500"
    }
  };
  return d.createElement(z, i({
    sx: o
  }, r), n);
},
    Mr = function Mr(e) {
  var t = e,
      n = t.children,
      r = c(t, ["children"]);
  return d.createElement(x, i({
    gridArea: "header",
    borderBottomWidth: {
      base: "none",
      md: "thin"
    },
    borderStyle: "dashed",
    borderColor: "grey.100",
    pb: {
      base: 0,
      md: 5
    },
    mb: {
      base: 0,
      md: 5
    }
  }, r), n);
},
    jr = function jr(e) {
  var t = e,
      n = t.children,
      r = c(t, ["children"]);
  return d.createElement(x, i({
    gridArea: "illustration"
  }, r), n);
},
    Ar = function Ar(e) {
  var t = e,
      n = t.children,
      r = c(t, ["children"]);
  return d.createElement(x, i({
    gridArea: "actions"
  }, r), n);
},
    Fr = function Fr(_ref38) {
  var e = _ref38.img,
      _ref38$size = _ref38.size,
      t = _ref38$size === void 0 ? 105 : _ref38$size,
      n = _ref38.icon,
      r = _ref38.className,
      _ref38$iconSize = _ref38.iconSize,
      o = _ref38$iconSize === void 0 ? 24 : _ref38$iconSize;
  var l = d.cloneElement(n, {
    className: L("image-icon", n.props.className),
    style: {
      width: o,
      height: o
    }
  });
  return d.createElement("div", {
    className: le("image-with-icon", r),
    style: {
      width: t,
      height: t
    }
  }, d.createElement(C, {
    className: L("image-main", r),
    src: e,
    width: t,
    height: t
  }), l);
};

var Br = function Br(_ref39) {
  var e = _ref39.day,
      t = _ref39.selectable,
      n = _ref39.active,
      r = _ref39.onClick;
  return d.createElement(lr, {
    h: 9,
    w: 9,
    px: 0,
    type: "button",
    disabled: !t,
    selected: n,
    onClick: t ? r : void 0
  }, e.day);
},
    Sr = function Sr() {
  var e = re.PlainDate.from("2021-09-06"),
      t = [1, 2, 3, 4, 5, 6, 7].map(function (t) {
    return d.createElement("div", {
      key: t
    }, e.add({
      days: t - 1
    }).toLocaleString("sv-SE", {
      weekday: "short",
      calendar: "iso8601"
    }));
  });
  return d.createElement(R, {
    color: "grey.600",
    textTransform: "uppercase",
    fontSize: "xs",
    fontWeight: "semibold",
    mb: 2.5,
    justifyItems: "center",
    gap: 2.5,
    templateColumns: "repeat(7, 1fr)"
  }, t);
},
    Zr = function Zr(_ref40) {
  var e = _ref40.children;
  return d.createElement(D, {
    as: "h3",
    fontSize: "sm",
    fontWeight: "normal",
    color: "grey.700"
  }, e);
},
    Vr = function Vr(_ref41) {
  var e = _ref41.times,
      t = _ref41.isDaySelectable,
      n = _ref41.onChange;

  var _u11 = u({
    activeMonth: re.PlainYearMonth.from(re.Now.plainDate("iso8601", "Europe/Stockholm")),
    activeDay: null,
    activeTime: null
  }),
      _u12 = _slicedToArray(_u11, 2),
      r = _u12[0],
      o = _u12[1],
      l = function l(e) {
    o({
      activeMonth: e,
      activeDay: null,
      activeTime: null
    }), n && n(null);
  },
      a = h(function () {
    return Array.from( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
      var t, n, r, o, l;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              t = e.toPlainDate({
                day: 1
              }), n = e.toPlainDate({
                day: e.daysInMonth
              }), r = 1 === t.dayOfWeek ? t : t.subtract({
                days: t.dayOfWeek - 1
              }), o = n.dayOfWeek === n.daysInWeek ? n : n.add({
                days: n.daysInWeek - n.dayOfWeek
              });
              l = r;

            case 2:
              if (!(re.PlainDate.compare(l, o) < 1)) {
                _context.next = 8;
                break;
              }

              _context.next = 5;
              return l;

            case 5:
              l = l.add({
                days: 1
              });

            case 6:
              _context.next = 2;
              break;

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })(r.activeMonth));
  }, [r.activeMonth]).map(function (e) {
    return d.createElement(Br, {
      key: e.toJSON(),
      day: e,
      selectable: !t || t(e),
      active: !!r.activeDay && e.equals(r.activeDay),
      onClick: function onClick(t) {
        t.preventDefault(), function (e) {
          e !== r.activeDay && (o({
            activeMonth: e.toPlainYearMonth(),
            activeDay: e,
            activeTime: null
          }), n && n(null));
        }(e);
      }
    });
  }),
      c = e(r.activeDay).map(function (e) {
    return d.createElement(lr, {
      type: "button",
      key: e.toJSON(),
      selected: null !== r.activeTime && e.equals(r.activeTime),
      onClick: function onClick() {
        return function (e) {
          o(s(i({}, r), {
            activeTime: e
          })), n && n(e.toZonedDateTime({
            plainDate: r.activeDay,
            timeZone: "Europe/Stockholm"
          }));
        }(e);
      }
    }, e.toLocaleString("sv-SE", {
      hour: "2-digit",
      minute: "2-digit",
      calendar: "iso8601"
    }));
  });

  return d.createElement(x, {
    maxW: "30rem"
  }, d.createElement(A, {
    align: "center",
    justify: "space-between",
    mb: 7
  }, d.createElement(Zr, null, "Tillgängliga datum:"), d.createElement(A, {
    alignItems: "center"
  }, d.createElement(x, {
    mr: 2.5,
    fontWeight: "semibold",
    textTransform: "capitalize",
    color: "grey.800",
    fontSize: "sm"
  }, r.activeMonth.toLocaleString("sv-SE", {
    month: "long",
    year: "numeric",
    calendar: "iso8601"
  })), d.createElement(S, {
    variant: "outline",
    size: "round-sm",
    mr: 1.5,
    onClick: function onClick() {
      return l(r.activeMonth.subtract({
        months: 1
      }));
    }
  }, d.createElement(ze, {
    width: "1em",
    height: "1em"
  })), d.createElement(S, {
    variant: "outline",
    size: "round-sm",
    onClick: function onClick() {
      return l(r.activeMonth.add({
        months: 1
      }));
    }
  }, d.createElement(Ve, {
    width: "1em",
    height: "1em"
  })))), d.createElement(Sr, null), d.createElement(R, {
    pb: 7,
    mb: 2.5,
    borderBottom: "thin solid",
    borderColor: "grey.100",
    justifyItems: "center",
    gap: 2.5,
    templateColumns: "repeat(7, 1fr)"
  }, a), r.activeDay && d.createElement(d.Fragment, null, d.createElement(Zr, null, "Tillgängliga tider:"), d.createElement(A, {
    css: {
      gap: "10px"
    },
    mb: 7,
    mt: 4,
    wrap: "wrap"
  }, c)));
},
    _r = function _r(e) {
  var t = k(null),
      n = k(null),
      _T = T(),
      r = _T.isOpen,
      o = _T.onClose,
      l = _T.onToggle,
      a = y("SelectDropdown", {}),
      _I = I({
    placement: "bottom-start"
  }),
      s = _I.popperRef,
      c = _I.referenceRef,
      m = $(n, s),
      u = $(t, c);

  P({
    ref: n,
    handler: function handler(e) {
      var n;
      (null == (n = t.current) ? void 0 : n.contains(e.target)) || o();
    },
    enabled: r
  });
  var p = e.options.map(function (t) {
    var n = t.value === e.value ? {
      color: "blue.500"
    } : {};
    return d.createElement(x, {
      as: "button",
      key: t.value,
      __css: i(i({}, a.option), n),
      onClick: function onClick() {
        return e.onChange(t.value);
      }
    }, t.display);
  }),
      h = e.options.find(function (t) {
    return t.value === e.value;
  });
  return d.createElement(d.Fragment, null, d.createElement(S, {
    variant: "outline",
    onClick: l,
    ref: u,
    justifyContent: "space-between",
    color: h ? "grey.800" : "grey.300",
    rightIcon: r ? d.createElement(M, {
      as: Ne,
      color: "blue.500",
      direction: "up",
      size: 8,
      w: 2
    }) : d.createElement(M, {
      as: Ne,
      color: "grey.800",
      direction: "down",
      size: 8,
      w: 2
    })
  }, h ? h.display : e.placeholder), d.createElement(x, {
    ref: m,
    hidden: !r,
    __css: a.list
  }, p));
},
    _oe = oe(),
    _oe2 = _slicedToArray(_oe, 4),
    Hr = _oe2[0],
    zr = _oe2[1],
    Rr = _oe2[2],
    Dr = _oe2[3],
    Tr = f(void 0),
    Ir = Tr.Provider,
    $r = function $r() {
  var e = g(Tr);
  if (!e) throw new Error("ContextError");
  return e;
},
    Pr = function Pr(e) {
  var t = function () {
    var e = Rr(),
        _u13 = u(0),
        _u14 = _slicedToArray(_u13, 2),
        t = _u14[0],
        n = _u14[1],
        _u15 = u(!1),
        _u16 = _slicedToArray(_u15, 2),
        r = _u16[0],
        o = _u16[1],
        l = v(function () {
      var r;
      n(null == (r = e.nextEnabled(t, !0)) ? void 0 : r.index);
    }, [e, t]),
        a = v(function () {
      var r;
      n(null == (r = e.prevEnabled(t, !0)) ? void 0 : r.index);
    }, [e, t]),
        i = v(function () {
      r || o(!0);
    }, [r]);

    return {
      currentSlide: t,
      goBackward: a,
      goForward: l,
      onHover: i,
      descendants: e
    };
  }(),
      n = t.descendants,
      r = c(t, ["descendants"]),
      o = e,
      l = o.children,
      a = c(o, ["children"]);

  return d.createElement(Hr, {
    value: n
  }, d.createElement(Ir, {
    value: r
  }, d.createElement(R, i({
    templateRows: "1fr 30px 1fr",
    templateColumns: "20px 1fr 20px"
  }, a), l)));
},
    Wr = function Wr(e) {
  var t = e,
      n = t.children,
      r = c(t, ["children"]);
  return d.createElement(x, i({
    as: "button",
    color: "blue.500",
    bg: "white",
    display: "inline-flex",
    alignItems: "center",
    position: "relative",
    _hover: {
      bg: "blue.500",
      color: "white"
    }
  }, r), n);
},
    Or = function Or(_ref42) {
  var e = _ref42.onClick;

  var _$r = $r(),
      t = _$r.goForward;

  return d.createElement(Wr, {
    gridArea: "2 / 3 / 3 / 4",
    onClick: function onClick(n) {
      t(), e && e(n);
    },
    paddingRight: 1,
    justifyContent: "end",
    borderLeftRadius: 4,
    "aria-label": "Go forward"
  }, d.createElement(Ne, {
    direction: "right",
    size: 10
  }));
},
    qr = function qr(_ref43) {
  var e = _ref43.onClick;

  var _$r2 = $r(),
      t = _$r2.goBackward;

  return d.createElement(Wr, {
    onClick: function onClick(n) {
      t(), e && e(n);
    },
    gridArea: "2 / 1 / 2 / 1",
    paddingLeft: 1,
    borderRightRadius: 4,
    "aria-label": "Go back"
  }, d.createElement(Ne, {
    direction: "left",
    size: 10
  }));
},
    Gr = function Gr(e) {
  var t = e,
      n = t.children,
      r = c(t, ["children"]),
      o = function () {
    var _$r3 = $r(),
        e = _$r3.currentSlide,
        _Dr = Dr(),
        t = _Dr.index,
        n = _Dr.register;

    return {
      ref: n,
      display: t === e ? "block" : "none",
      inDom: t === e
    };
  }(),
      l = o.inDom,
      a = c(o, ["inDom"]);

  return d.createElement(x, s(i(i({}, a), r), {
    gridArea: "1 / 1 / 4 / 4"
  }), l && n);
},
    Yr = O({
  components: {
    Tabs: {
      parts: ["tab", "tablist", "tabpanel"],
      sizes: {
        "round-md": {
          tab: {
            boxSize: {
              base: 26,
              md: 30
            }
          }
        }
      },
      variants: {
        round: {
          tab: {
            position: "relative",
            borderRadius: "50%",
            background: "white",
            color: "grey.800",
            fontWeight: "semibold",
            _hover: {
              borderColor: "blue.500",
              borderWidth: "thin",
              borderStyle: "solid"
            },
            _selected: {
              background: "blue.500",
              color: "white"
            }
          },
          tablist: {
            gap: 8
          },
          tabpanel: {
            padding: 0,
            paddingTop: 2
          }
        }
      }
    },
    Button: {
      sizes: {
        md: {
          h: "2.625rem",
          minW: "8.5rem"
        },
        "round-sm": {
          h: 6,
          w: 6,
          borderRadius: "full",
          fontSize: "0.5rem",
          flexShrink: 0
        },
        "round-md": {
          h: "2.625rem",
          w: "2.625rem",
          borderRadius: "full",
          flexShrink: 0
        }
      },
      variants: {
        solid: function solid(_ref44) {
          var e = _ref44.colorScheme;
          return {
            bg: "".concat(e, ".500"),
            color: "white",
            _hover: {
              bg: "".concat(e, ".600")
            }
          };
        },
        outline: function outline(_ref45) {
          var e = _ref45.colorScheme;
          return {
            borderColor: "grey.100",
            color: "".concat(e, ".500"),
            _hover: {
              borderColor: "".concat(e, ".500"),
              bg: "transparent"
            }
          };
        },
        link: function link(_ref46) {
          var e = _ref46.colorScheme;
          return {
            color: "".concat(e, ".500"),
            fontWeight: "normal",
            minW: 0
          };
        }
      },
      defaultProps: {
        colorScheme: "blue"
      }
    },
    TagButton: {
      baseStyle: {
        lineHeight: "1.2",
        borderRadius: "full",
        fontWeight: "semibold",
        transitionProperty: "common",
        transitionDuration: "normal",
        _focus: {
          boxShadow: "outline"
        },
        _disabled: {
          opacity: .4,
          cursor: "not-allowed",
          boxShadow: "none"
        },
        _hover: {
          _disabled: {
            bg: "initial"
          }
        }
      },
      sizes: {
        sm: {
          h: 7,
          fontSize: "xs",
          px: 3.5
        },
        md: {
          h: {
            base: 9,
            md: 10
          },
          px: {
            base: 3.5,
            md: 4
          }
        }
      },
      variants: {
        solid: function solid(_ref47) {
          var e = _ref47.selected;
          return e ? {
            bg: "blue.500",
            color: "white",
            _active: {
              bg: "blue.700"
            }
          } : {
            bg: "blue.50",
            _hover: {
              bg: "blue.100"
            },
            _active: {
              bg: "blue.300"
            }
          };
        }
      },
      defaultProps: {
        variant: "solid",
        size: "md"
      }
    },
    Input: {
      parts: ["field", "element"],
      baseStyle: {
        field: {
          _placeholder: {
            opacity: 1,
            color: "grey.400"
          }
        }
      },
      sizes: {
        "round-lg": {
          field: {
            px: 7,
            h: 12,
            borderRadius: "full"
          }
        }
      },
      variants: {
        outline: {
          field: {
            borderColor: "grey.100",
            color: "grey.400",
            _focus: {
              color: "grey.800",
              borderColor: "blue.500",
              fontWeight: "semibold"
            },
            _hover: {
              borderColor: "blue.400"
            }
          }
        }
      }
    },
    FormLabel: {
      baseStyle: {
        fontSize: "xs",
        color: "grey.500",
        fontWeight: "normal",
        mb: 0
      },
      variants: {
        "on-border": {
          position: "absolute",
          left: 1,
          top: -3,
          padding: 1,
          paddingTop: 0,
          zIndex: 2,
          bgColor: "white"
        }
      }
    },
    Form: {
      parts: ["helperText"],
      baseStyle: {
        helperText: {
          fontSize: "xs",
          color: "grey.500",
          fontWeight: "normal"
        }
      }
    },
    SelectDropdown: {
      parts: ["list", "option", "button"],
      baseStyle: function baseStyle(e) {
        return {
          list: i({}, W.components.Menu.baseStyle(e).list),
          option: s(i({}, W.components.Menu.baseStyle(e).item), {
            textDecoration: "none",
            color: "inherit",
            userSelect: "none",
            display: "flex",
            width: "100%",
            alignItems: "center",
            textAlign: "start",
            flex: "0 0 auto",
            outline: 0,
            fontSize: "sm",
            fontWeight: "medium",
            _hover: {
              bg: "blue.50"
            }
          })
        };
      }
    },
    Card: {
      baseStyle: function baseStyle(_ref48) {
        var e = _ref48.colorScheme;
        return {
          borderWidth: 1,
          borderLeftWidth: 4,
          borderStyle: "solid",
          borderColor: "grey.100",
          borderLeftColor: "".concat(e, ".500"),
          borderRadius: "base",
          px: 6,
          pt: 5,
          pb: {
            base: 5,
            md: 6
          }
        };
      }
    },
    Banner: {
      parts: ["banner", "avatar", "starIconWrapper", "starIcon", "heading", "subHeading"],
      baseStyle: {
        banner: {
          bgColor: "green.500",
          display: "grid",
          borderRadius: "base",
          color: "white",
          _hover: {
            bg: "green.600"
          }
        },
        avatar: {
          borderRadius: "full",
          position: "relative"
        },
        starIconWrapper: {
          padding: 1,
          borderRadius: "full",
          bgColor: "white",
          position: "absolute",
          right: 0,
          bottom: 0
        },
        heading: {
          fontWeight: "semibold"
        },
        subHeading: {
          fontStyle: "italic"
        }
      },
      variants: {
        horizontal: {
          banner: {
            gridTemplate: "min-content min-content / min-content 1fr ",
            gridColumnGap: {
              base: 5,
              lg: 8
            },
            rowGap: {
              base: 1,
              md: 4
            }
          },
          avatar: {
            gridColumn: "1 / 2",
            gridRow: "1 / 3",
            alignSelf: "center"
          },
          heading: {
            fontSize: {
              base: "lg",
              sm: "4xl"
            },
            gridColumn: "2 / 3",
            gridRow: "1 / 2",
            alignSelf: "end"
          },
          subHeading: {
            fontSize: {
              base: "xs",
              sm: "sm"
            },
            gridColumn: "2 / 3",
            gridRow: "2 / 3",
            alignSelf: "start"
          }
        },
        float: {
          banner: {
            padding: 6,
            w: 44,
            gridTemplateRows: "auto auto auto",
            gridRowGap: 4
          },
          avatar: {
            gridRow: "1 / 2",
            justifySelf: "center"
          },
          heading: {
            gridRow: "2 / 3",
            fontSize: "lg"
          },
          subHeading: {
            gridRow: "3 / 4",
            fontSize: "xs"
          }
        }
      },
      sizes: {
        md: {
          heading: {},
          subheading: {}
        },
        lg: {
          banner: {
            px: {
              base: 4,
              md: 5,
              lg: 7
            },
            py: {
              base: 4,
              md: 5,
              lg: 7
            }
          },
          heading: {
            fontSize: {
              base: "lg",
              md: "xl",
              lg: "2xl"
            }
          },
          subheading: {
            fontSize: {
              base: "xs",
              lg: "sm"
            }
          }
        },
        xl: {
          banner: {
            px: {
              base: 4,
              md: 6,
              lg: 8
            },
            py: {
              base: 4,
              md: 6,
              lg: 10
            }
          },
          heading: {
            fontSize: {
              base: "lg",
              md: "2xl",
              lg: "4xl"
            }
          },
          subheading: {
            fontSize: {
              base: "xs",
              lg: "sm"
            }
          }
        }
      },
      defaultProps: {
        variant: "horizontal"
      }
    },
    Link: {
      variants: {
        black: {
          color: "gray.600",
          _hover: {
            color: "gray.800",
            textDecoration: "underline"
          }
        },
        blue: {
          color: "blue.500",
          _hover: {
            color: "blue.600",
            textDecoration: "none"
          }
        }
      }
    },
    BorderedForm: {
      parts: ["box", "formlabel", "divider"],
      baseStyle: {
        box: {
          borderWidth: 1
        },
        formlabel: {
          color: "rgba(0,0,0,0.6)",
          fontSize: "xs"
        }
      },
      variants: {
        horizontal: {
          box: {
            padding: 1,
            paddingLeft: 5,
            gridGap: 4,
            borderRadius: "full",
            display: "inline-flex",
            alignItems: "center"
          },
          formlabel: {
            left: -1,
            top: -4,
            padding: 1,
            paddingTop: 0,
            bgColor: "white",
            position: "absolute"
          },
          divider: {
            borderLeftWidth: 1,
            borderLeftStyle: "solid",
            height: 10
          }
        },
        vertical: {
          box: {
            padding: 5,
            borderRadius: "md",
            alignItems: "center",
            gap: 2.5
          },
          divider: {
            alignSelf: "center",
            marginBottom: 4
          }
        }
      },
      defaultProps: {
        variant: "horizontal"
      }
    }
  },
  fonts: {
    body: "FaktPro, Roboto, sans-serif",
    heading: "FaktPro, Roboto, sans-serif"
  },
  colors: {
    black: "#000",
    white: "#fff",
    green: {
      50: "#F4FDFA",
      500: "#1DCE93",
      600: "#1AB984"
    },
    yellow: {
      500: "#ECC11D"
    },
    blue: {
      50: "#F2F8FF",
      100: "#CEE6FF",
      200: "#99caff",
      500: "#007aff",
      600: "#006EE6"
    },
    grey: {
      100: "rgba(0, 0, 0, 0.15)",
      300: "rgba(51, 62, 72, 0.4)",
      400: "rgba(0, 0, 0, 0.4)",
      500: "rgba(0, 0, 0, 0.6)",
      600: "#999999",
      700: "#333e48",
      800: "rgba(0, 0, 0, 0.8)"
    }
  }
}),
    Ur = "#999999",
    Jr = ee({
  palette: {
    primary: {
      main: "#007aff"
    },
    action: {
      disabledBackground: "#eaedf0"
    },
    text: {
      primary: "#3e5062",
      secondary: Ur
    }
  },
  typography: {
    fontFamily: ["FaktPro", "Roboto", "sans-serif"].join(","),
    h1: {
      fontSize: "34px",
      fontWeight: 500,
      lineHeight: "52px",
      textAlign: "left"
    },
    h4: {
      fontSize: "20px",
      lineHeight: "27px"
    },
    h5: {
      fontSize: "20px",
      textTransform: "uppercase"
    }
  },
  overrides: {
    MuiButton: {
      containedPrimary: {
        color: "white",
        "&:hover": {
          color: "white"
        }
      }
    },
    MuiFormControlLabel: {
      label: {
        color: Ur
      }
    },
    MuiScopedCssBaseline: {
      root: {
        backgroundColor: "transparent"
      }
    },
    MuiOutlinedInput: {
      root: {
        background: "white"
      },
      notchedOutline: {
        "&>legend": {
          maxWidth: "1000px"
        }
      }
    }
  }
}),
    Xr = function Xr(e) {
  var t = e,
      n = t.value,
      r = t.name,
      o = c(t, ["value", "name"]);
  return d.createElement(A, i({
    css: {
      gap: "4px"
    }
  }, o), d.createElement(Z, {
    as: "dt",
    color: "grey.500"
  }, r, ":"), d.createElement(Z, {
    as: "dd",
    fontWeight: "semibold",
    color: "grey.800"
  }, n));
},
    Kr = function Kr(e) {
  var t = e,
      n = t.children,
      r = t.colorScheme,
      o = c(t, ["children", "colorScheme"]);
  var l = j("Card", {
    colorScheme: r
  });
  return d.createElement(x, i({
    __css: l
  }, o), n);
},
    Qr = function Qr(e) {
  var t = e,
      n = t.children,
      r = c(t, ["children"]);
  return d.createElement(x, i({
    bg: "green.50",
    p: 6,
    color: "grey.500"
  }, r), n);
},
    eo = function eo(e) {
  var t = e,
      n = t.children,
      r = c(t, ["children"]);
  return d.createElement(x, i({
    as: "section",
    py: 7,
    borderTop: "1px",
    borderColor: "grey.100",
    gridColumnStart: "1"
  }, r), n);
},
    to = function to(e) {
  var t = e,
      n = t.children,
      r = c(t, ["children"]);
  return d.createElement(D, i({
    as: "h1",
    fontSize: {
      base: "lg",
      md: "xl",
      lg: "2xl"
    },
    color: "grey.800",
    fontWeight: "semibold",
    mb: 3
  }, r), n);
},
    no = function no(e) {
  var t = e,
      n = t.children,
      r = c(t, ["children"]);
  return d.createElement(x, i({
    as: "article",
    display: "grid",
    gridTemplateColumns: {
      base: "1fr",
      lg: "1fr 20rem"
    },
    gridColumnGap: {
      base: 0,
      lg: 4
    },
    gridTemplateRows: "min-content 5.5rem min-content 5.5rem 1fr"
  }, r), n);
},
    ro = function ro(e) {
  var t = e,
      n = t.children,
      r = c(t, ["children"]);
  return d.createElement(x, i({
    gridArea: "2 / 1 / 5 / 3",
    mb: 7
  }, r), n);
},
    oo = function oo(e) {
  var t = e,
      n = t.children,
      r = c(t, ["children"]);
  return d.createElement(x, i({
    as: "aside",
    gridArea: {
      base: "auto / 1 / auto / 2",
      lg: "3 / 2 / 4 / 3"
    },
    order: {
      base: 10,
      lg: "unset"
    },
    position: "sticky",
    top: {
      base: "auto",
      lg: 10
    },
    bottom: {
      base: 0,
      lg: "auto"
    },
    py: 7,
    px: 6,
    mx: {
      base: "-1rem",
      lg: 0
    },
    bg: "white",
    borderRadius: "base",
    height: "min-content",
    transform: {
      base: "none",
      lg: "translateX(24px)"
    },
    border: "1px",
    borderColor: "grey.100",
    shadow: {
      base: "0px 0px 20px rgba(0, 0, 0, 0.15)",
      lg: "xl"
    }
  }, r), n);
},
    lo = function lo(e) {
  var t = e,
      n = t.children,
      r = c(t, ["children"]);
  return d.createElement(x, i({
    as: "main",
    gridArea: "5 / 1 / 6 / 2"
  }, r), n);
},
    ao = function ao(e) {
  var t = e,
      n = t.children,
      r = c(t, ["children"]);
  return d.createElement(x, i({
    as: "header",
    gridArea: "1 / 1 / 2 / -1",
    mb: 4
  }, r), n);
};

export { $e as ArrowDownIcn, At as ArrowLeftButton, Ft as ArrowRightButton, Ie as ArrowUpIcn, Gt as Banner, Yt as BannerAvatar, Ut as BannerHeading, Jt as BannerSubHeading, Pe as BarcodeScanIcn, We as BathroomShowerIcn, Oe as BedWindowIcn, Ct as BicycleSportsIcn, Ht as BlueArrowButtonsGroup, we as BlueStrokeButton, he as BodyText, Le as BoldPrimaryButton, or as BorderedForm, qe as BreakfastCroissantIcn, Ge as CalendarClockIcn, Ye as CalendarHomeIcn, Kr as Card, vn as CardBlock, Pr as Carousel, qr as CarouselBackArrow, Or as CarouselForwardArrow, Gr as CarouselSlide, Ue as CloseIcn, Je as CoffeeCupHotIcn, wr as ColorLegend, Rt as ConfirmButton, eo as ContentSection, to as ContentSectionHeading, cr as Conversation, mr as ConversationQuestion, Vr as DateTimePicker, ge as DocumentPreview, Xe as DogIcn, Un as Dropdown, ur as EmbedForm, Ke as EnvelopeIcn, Ee as ErrorText, Qe as ExpandIcn, Bn as ExpertMainContent, ke as FactPin, Xr as Feature, Mt as FillableHeartIcn, et as FilterIcn, tt as FitnessDumbbellIcn, Xt as FixedWidthContent, Lr as Footer, In as FullWidthImage, Tn as GdprConsent, fn as GreenEdgeCard, xe as GreyStrokeButton, Vt as GridItem, se as Headline, me as HeadlineLabel, St as HorizontalGridContainer, ie as Hypertext, Ne as IcnArrow, Me as IcnCheckmark, je as IcnCross, Ae as IcnEmail, Fe as IcnFacebook, Be as IcnLinkedIn, Se as IcnNavMenu, Ze as IcnPhone, Ve as IcnRightArrow, _e as IcnStar, He as IcnTwitter, ze as IcnWhiteLeftArrow, Re as IcnYtaLogo, Fr as ImageWithIcon, yn as ImgCard, Qr as Info, nt as InformationDeskManIcn, Xn as InlineMultiChoice, rr as InputDivider, nr as InputLabel, kn as LegacyCard, En as LegacyCarousel, rt as LiftTwoPeopleIcn, Dt as LinkButton, Tt as LinkSelectedButton, Nr as ListResult, Ar as ListResultActions, Mr as ListResultHeader, jr as ListResultIllustration, er as MUISelectField, tr as MUITextInputField, Jr as MUITheme, yr as MapLegend, ot as MapPinIcn, xr as MapPopup, at as MapsIcn, lt as MapsPinIcn, Nt as MapsSearchIcn, zn as MarkdownContent, it as MicrophonePodcastPersonIcn, Cr as ModalContent, Kn as MultiChoiceDisplayValue, ar as MultiInputBox, ir as MultiSelectDropdown, st as NavigationMenuIcn, jn as NormalExpertCard, ct as OfficeChairIcn, mt as OfficeDeskIcn, Gn as OptionsList, Sn as OrderedListContent, cn as PageSection, ae as Paragraph, dt as ParkingIcn, ut as PhoneIcn, pt as PinIcn, wt as PresentationIcn, ve as PrimaryButton, ht as RealEstateDimensionsBlockIcn, Et as RestaurantForkKnifeIcn, bt as RightArrowIcn, Wn as RoundedTextInput, Te as SearchIcn, jt as SearchQuestionmarkIcn, ce as SecondaryHeadline, mn as Section, pn as SectionFooter, un as SectionLogoGroup, _r as Select, Jn as SelectDropdown, Kt as Shape2, Qt as Shape3, en as Shape4, tn as Shape5, nn as Shape6, rn as Shape7, oo as SingleAside, lo as SingleBody, _n as SingleExpertContent, ao as SingleHeader, ro as SingleHero, no as SingleLayout, kt as SingleNeutralIdCardIcn, An as SmallExpertCard, On as SquaredTextInput, xt as StarVeridiedIcon, De as StreamlineIcon, br as StripePattern, pe as SubHeadline, dr as SubmitConfirmation, gt as SynchronizeArrowsIcn, ft as TableRestaurantBeachIcn, It as TagButton, Dn as TeamContent, Zn as TestimonialMainContent, Pn as TextInput, $n as Tooltip, pr as TopContent, hr as TopHero, kr as TopMenu, Cn as TsCard, Vn as ValuePropositionMainContent, sr as VerifiedSign, Zt as VerticalGridContainer, wn as VpCard, yt as WaitingRoomLampIcn, vt as WarehouseStorageIcn, ye as WhiteStrokeButton, Lt as WineGlassIcn, zt as YellowArrowButtonsGroup, gn as YellowEdgeCard, Yr as chakraTheme, Qn as formParams };